/* Use translation-fetcher.ps1 to generate keys */

import React from "react";
import { getOrCreateGlobalFancyContext } from "@siteimprove/fancylib";

// Location: REPORTS_SCHEDULE_MANAGE
// Name: REPORT_OCCURRENCE_DAY_1
const first = {
	"en-US": "First",
	"en-GB": "First",
	"da-DK": "Første",
	"sv-SE": "Första",
	"de-DE": "Ersten",
	"nb-NO": "Første",
	"fr-FR": "Premier",
	"es-ES": "Primer",
	"it-IT": "Primo",
	"nl-NL": "Eerste",
	"pt-BR": "Primeiro",
	"fi-FI": "Ensimmäinen",
	"ja-JP": "第1",
};

// Location: REPORTS_SCHEDULE_MANAGE
// Name: REPORT_OCCURRENCE_DAY_5
const last = {
	"en-US": "Last",
	"en-GB": "Last",
	"da-DK": "Sidste",
	"sv-SE": "Sista",
	"de-DE": "Letzten",
	"nb-NO": "Siste",
	"fr-FR": "Dernier",
	"es-ES": "Último",
	"it-IT": "Ultimo",
	"nl-NL": "Laatste ",
	"pt-BR": "Últimos",
	"fi-FI": "Viimeinen",
	"ja-JP": "最終",
};

// Location: Siteimprove.UI.Pager
// Name: PAGINATION_PREVIOUS
const previous = {
	"en-US": "Previous",
	"en-GB": "Previous",
	"da-DK": "Forrige",
	"sv-SE": "Föregående",
	"de-DE": "Zurück",
	"nb-NO": "Forrige",
	"fr-FR": "Page précédente",
	"es-ES": "Anterior",
	"it-IT": "Precedente",
	"nl-NL": "Vorige",
	"pt-BR": "Anterior",
	"fi-FI": "Edellinen",
	"ja-JP": "前へ",
};

// Location: Siteimprove.UI.Pager
// Name: PAGINATION_NEXT
const next = {
	"en-US": "Next",
	"en-GB": "Next",
	"da-DK": "Næste",
	"sv-SE": "Nästa",
	"de-DE": "Weiter",
	"nb-NO": "Neste",
	"fr-FR": "Page suivante",
	"es-ES": "Siguiente",
	"it-IT": "Successiva",
	"nl-NL": "Volgende",
	"pt-BR": "Próximo",
	"fi-FI": "Seuraava",
	"ja-JP": "次へ",
};

// Location: GLOBAL
// Name: PAGE
const page = {
	"en-US": "Page",
	"en-GB": "Page",
	"da-DK": "Side",
	"sv-SE": "Sida",
	"de-DE": "Seite",
	"nb-NO": "Side",
	"fr-FR": "Page",
	"es-ES": "Página",
	"it-IT": "Pagina",
	"nl-NL": "Pagina",
	"pt-BR": "Página",
	"fi-FI": "Sivu",
	"ja-JP": "ページ",
};

// Location: Siteimprove.UI.Pager
// Name: PAGINATION_PAGE_X_OF_Y
const pageXofY = {
	"en-US": "Page [PAGE] of [NUMBER_OF_PAGES]",
	"en-GB": "Page [PAGE] of [NUMBER_OF_PAGES]",
	"da-DK": "Side [PAGE] af [NUMBER_OF_PAGES]",
	"sv-SE": "Sida [PAGE] av [NUMBER_OF_PAGES]",
	"de-DE": "Seite [PAGE] von [NUMBER_OF_PAGES]",
	"nb-NO": "Side [PAGE] av [NUMBER_OF_PAGES]",
	"fr-FR": "Page [PAGE] sur [NUMBER_OF_PAGES]",
	"es-ES": "Página [PAGE] de [NUMBER_OF_PAGES]",
	"it-IT": "Pagina [PAGE] di [NUMBER_OF_PAGES]",
	"nl-NL": "Pagina [PAGE] van [NUMBER_OF_PAGES] ",
	"pt-BR": "Página [PAGE] de [NUMBER_OF_PAGES]",
	"fi-FI": "Sivu [PAGE]/[NUMBER_OF_PAGES]",
	"ja-JP": "ページ[PAGE]/[NUMBER_OF_PAGES]",
};

// Location: Siteimprove.UI.Pager
// Name: PAGINATION_ERROR_DEFAULT
const defaultError = {
	"en-US": "Invalid input.",
	"en-GB": "Invalid input.",
	"da-DK": "Ugyldig indtastning.",
	"sv-SE": "Ogiltig inmatning.",
	"de-DE": "Ungültige Eingabe.",
	"nb-NO": "Ugyldige inndata.",
	"fr-FR": "Entrée non valide.",
	"es-ES": "Entrada no válida.",
	"it-IT": "Input non valido.",
	"nl-NL": "Ongeldige invoer.",
	"pt-BR": "Entrada inválida.",
	"fi-FI": "Virheellinen syöte.",
	"ja-JP": "無効な入力です。",
};

// Location: Siteimprove.UI.Pager
// Name: PAGINATION_ERROR_WHOLE_NUMBER
const wholeNumberError = {
	"en-US": "Must be a whole number.",
	"en-GB": "Must be a whole number.",
	"da-DK": "Skal være et heltal.",
	"sv-SE": "Måste vara ett heltal.",
	"de-DE": "Dies muss eine Ganzzahl sein.",
	"nb-NO": "Må være et heltall.",
	"fr-FR": "Doit être un nombre entier.",
	"es-ES": "Debe ser un número entero.",
	"it-IT": "Deve essere un numero intero.",
	"nl-NL": "Moet een afgerond getal zijn.",
	"pt-BR": "Deve ser um número inteiro.",
	"fi-FI": "Oltava kokonaisluku.",
	"ja-JP": "整数を入力してください。",
};

// Location: Siteimprove.UI.Pager
// Name: PAGINATION_ERROR_OUT_OF_BOUNDS
const outOfBoundsError = {
	"en-US": "Enter a number between 1 and [NUMBER_OF_PAGES].",
	"en-GB": "Enter a number between 1 and [NUMBER_OF_PAGES].",
	"da-DK": "Indtast et tal mellem 1 og [NUMBER_OF_PAGES].",
	"sv-SE": "Ange ett nummer mellan 1 och [NUMBER_OF_PAGES].",
	"de-DE": "Geben Sie eine Zahl zwischen 1 und [NUMBER_OF_PAGES] ein.",
	"nb-NO": "Angi et tall mellom 1 og [NUMBER_OF_PAGES].",
	"fr-FR": "Entrez un nombre compris entre 1 et [NUMBER_OF_PAGES].",
	"es-ES": "Especifique un número del 1 al [NUMBER_OF_PAGES].",
	"it-IT": "Immettere un numero compreso tra 1 e [NUMBER_OF_PAGES].",
	"nl-NL": "Voer een nummer in tussen 1 en [NUMBER_OF_PAGES].",
	"pt-BR": "Digite um número entre 1 e [NUMBER_OF_PAGES].",
	"fi-FI": "Kirjoita numero välillä 1–[NUMBER_OF_PAGES].",
	"ja-JP": "1から[NUMBER_OF_PAGES]までの数字を入力してください。",
};

// Location: MESSAGE
// Name: MESSAGE_NEUTRAL
const messageNeutral = {
	"en-US": "Neutral message",
	"en-GB": "Neutral message",
	"da-DK": "Neutral meddelelse",
	"sv-SE": "Neutralt meddelande",
	"de-DE": "Neutrale Meldung",
	"nb-NO": "Nøytral melding",
	"fr-FR": "Message neutre",
	"es-ES": "Mensaje neutro",
	"it-IT": "Messaggio neutro",
	"nl-NL": "Neutraal bericht",
	"pt-BR": "",
	"fi-FI": "Neutraali viesti",
	"ja-JP": "中立的なメッセージ",
};

// Location: MESSAGE
// Name: MESSAGE_POSITIVE
const messagePositive = {
	"en-US": "Success message",
	"en-GB": "Success message",
	"da-DK": "Succesmeddelelse",
	"sv-SE": "Framgångsmeddelande",
	"de-DE": "Erfolgsmeldung",
	"nb-NO": "Melding om suksess",
	"fr-FR": "Message de réussite",
	"es-ES": "Mensaje de éxito",
	"it-IT": "Messaggio di successo",
	"nl-NL": "Succesbericht",
	"pt-BR": "",
	"fi-FI": "Onnistumisviesti",
	"ja-JP": "成功メッセージ",
};

// Location: MESSAGE
// Name: MESSAGE_WARNING
const messageWarning = {
	"en-US": "Warning message",
	"en-GB": "Warning message",
	"da-DK": "Advarselsmeddelelse",
	"sv-SE": "Varningsmeddelande",
	"de-DE": "Warnmeldung",
	"nb-NO": "Melding med advarsel",
	"fr-FR": "Message d'avertissement",
	"es-ES": "Mensaje de advertencia",
	"it-IT": "Messaggio di avviso",
	"nl-NL": "Waarschuwingsbericht",
	"pt-BR": "",
	"fi-FI": "Varoitusviesti",
	"ja-JP": "警告メッセージ",
};

// Location: MESSAGE
// Name: MESSAGE_NEGATIVE
const messageNegative = {
	"en-US": "Error message",
	"en-GB": "Error message",
	"da-DK": "Fejlmeddelelse",
	"sv-SE": "Felmeddelande",
	"de-DE": "Fehlermeldung",
	"nb-NO": "Feilmelding",
	"fr-FR": "Message d'erreur",
	"es-ES": "Mensaje de error",
	"it-IT": "Messaggio di errore",
	"nl-NL": "Foutmelding",
	"pt-BR": "",
	"fi-FI": "Virheviesti",
	"ja-JP": "エラーメッセージ",
};

// Location: MESSAGE
// Name: DISMISS_MESSAGE
const dismissMessage = {
	"en-US": "Dismiss message",
	"en-GB": "Dismiss message",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// Location: CHART
// Name: SKIP_CHART
const skipChart = {
	"en-US": "Skip chart",
	"en-GB": "Skip chart",
	"da-DK": "Spring diagram over",
	"sv-SE": "Hoppa över diagrammet",
	"de-DE": "Diagramm überspringen",
	"nb-NO": "Hopp over diagrammet",
	"fr-FR": "Ignorer le graphique",
	"es-ES": "Omitir gráfico",
	"it-IT": "Ignora grafico",
	"nl-NL": "Grafiek overslaan",
	"pt-BR": "",
	"fi-FI": "Ohita kaavio",
	"ja-JP": "チャートをスキップ",
};

// Location: FANCY_CHART
// Name: SCREEN_READER_REGION_LABEL
const chartScreenReaderRegionLabel = {
	"en-US": "Chart",
	"en-GB": "Chart",
	"da-DK": "Diagram",
	"sv-SE": "Diagram",
	"de-DE": "Diagramm",
	"nb-NO": "Diagram",
	"fr-FR": "Graphique",
	"es-ES": "Gráfico",
	"it-IT": "Grafico",
	"nl-NL": "Grafiek",
	"pt-BR": "",
	"fi-FI": "Kuvaaja",
	"ja-JP": "グラフ",
};

// Location: FANCY_CHART
// Name: SCREEN_READER_CHART_HEADING
const screenReaderChartHeading = {
	"en-US": "Chart graphic",
	"en-GB": "Chart graphic",
	"da-DK": "Diagramgrafik",
	"sv-SE": "Diagramgrafik",
	"de-DE": "Diagrammgrafik",
	"nb-NO": "Diagramgrafikk",
	"fr-FR": "Diagramme graphique",
	"es-ES": "Gráfico",
	"it-IT": "Grafico",
	"nl-NL": "Grafiek",
	"pt-BR": "",
	"fi-FI": "Kaaviokuva",
	"ja-JP": "グラフ画像",
};

// Location: FANCY_CHART
// Name: DEFAULT_CHART_TITLE
const defaultChartTitle = {
	"en-US": "Chart title",
	"en-GB": "Chart title",
	"da-DK": "Diagramtitel",
	"sv-SE": "Diagramtitel",
	"de-DE": "Diagrammtitel",
	"nb-NO": "Diagramtittel",
	"fr-FR": "Titre du graphique",
	"es-ES": "Título del gráfico",
	"it-IT": "Titolo del grafico",
	"nl-NL": "Grafiektitel",
	"pt-BR": "",
	"fi-FI": "Kuvaajan otsikko",
	"ja-JP": "グラフのタイトル",
};

// Location: FANCY_CHART
// Name: TABLE_SUMMARY
const chartTableSummary = {
	"en-US": "Table representation of chart.",
	"en-GB": "Table representation of chart.",
	"da-DK": "Gengivelse af diagrammet i tabelform.",
	"sv-SE": "Tabellversion av diagram.",
	"de-DE": "Tabellendarstellung des Diagramms.",
	"nb-NO": "Tabellrepresentasjon av diagrammet.",
	"fr-FR": "Représentation tabulaire du graphique.",
	"es-ES": "Representación en tabla del gráfico.",
	"it-IT": "Rappresentazione tabulare del grafico.",
	"nl-NL": "Tabelweergave van de grafiek.",
	"pt-BR": "",
	"fi-FI": "Kaavion taulukkoesitys.",
	"ja-JP": "グラフのテーブル表現。",
};

// Location: FANCY_CHART
// Name: CHART_CONTAINER_LABEL
const chartContainerLabel = {
	"en-US": "{title}. Use up and down arrows to navigate with most screen readers.",
	"en-GB": "{title}. Use up and down arrows to navigate with most screen readers.",
	"da-DK": "{title}. Du kan bruge Pil op og Pil ned til at navigere i de fleste skærmlæsere.",
	"sv-SE": "{title}. Använd upp- och nedpilarna för att navigera med de flesta skärmläsare.",
	"de-DE":
		"{title}. Über die Aufwärts- und Abwärtspfeile können Sie in den meisten Screen Readers navigieren.",
	"nb-NO": "{title}. Bruk pil opp og ned til å navigere med de fleste skjermlesere.",
	"fr-FR":
		"{title}. Utilisez les flèches haut et bas pour naviguer avec la plupart des lecteurs d’écran.",
	"es-ES":
		"{title}. Use las flechas hacia arriba y hacia abajo para navegar con la mayoría de los lectores de pantalla.",
	"it-IT":
		"{title}. Utilizza le frecce verso l'alto e verso il basso per navigare con la maggior parte dei lettori di schermo.",
	"nl-NL": "{title}. Gebruik de omhoog en omlaag pijl om met de meeste schermlezers te navigeren.",
	"pt-BR": "",
	"fi-FI": "{title}. Useimmissa ruudunlukijoissa voit liikkua ylä- ja alanuolilla.",
	"ja-JP": "{title}。上矢印と下矢印を使用して、ほとんどのスクリーンリーダーを操作します。",
};

// Location: FANCY_CHART
// Name: LEGEND_ITEM
const chartLegendItem = {
	"en-US": "Enable series: {itemName}",
	"en-GB": "Enable series: {itemName}",
	"da-DK": "Aktivér serie: {itemName}",
	"sv-SE": "Aktivera serier: {itemName}",
	"de-DE": "Datenreihe aktivieren: {itemName}",
	"nb-NO": "Aktiver serie: {itemName}",
	"fr-FR": "Activer la série : {itemName}",
	"es-ES": "Habilitar serie: {itemName}",
	"it-IT": "Abilita serie: {itemName}",
	"nl-NL": "Serie inschakelen: {itemName}",
	"pt-BR": "",
	"fi-FI": "Ota sarja käyttöön: {itemName}",
	"ja-JP": "有効にするシリーズ： {itemName}",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_MAP_TYPE_DESCRIPTION
const chartTypesMapTypeDescription = {
	"en-US": "Map of {mapTitle} with {numSeries} data series.",
	"en-GB": "Map of {mapTitle} with {numSeries} data series.",
	"da-DK": "Kort over {mapTitle} med {numSeries} dataserier.",
	"sv-SE": "Karta över {mapTitle} med {numSeries} dataserier.",
	"de-DE": "Abbildung von {mapTitle} mit {numSeries} Datenreihen.",
	"nb-NO": "Kart over {mapTitle} med dataserie {numSeries}.",
	"fr-FR": "Carte de {mapTitle} avec {numSeries} séries de données.",
	"es-ES": "Mapa de {mapTitle} con {numSeries} series de datos.",
	"it-IT": "Mappa di {mapTitle} con {numSeries} serie di dati.",
	"nl-NL": "Kaart van {mapTitle} met {numSeries} datareeks.",
	"pt-BR": "",
	"fi-FI": "Kartta {mapTitle}, jossa {numSeries} arvosarjaa.",
	"ja-JP": "データ系列の数が{numSeries}個の{mapTitle}のマップ。",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_COMBINATION_CHART
const chartTypesCombinationChart = {
	"en-US": "Combination chart with {numSeries} data series.",
	"en-GB": "Combination chart with {numSeries} data series.",
	"da-DK": "Kombinationsdiagram med {numSeries} dataserier.",
	"sv-SE": "Kombinationsdiagram med {numSeries} dataserier.",
	"de-DE": "Kombinationsdiagramm mit {numSeries} Datenreihen.",
	"nb-NO": "Kombinasjonsdiagram med {numSeries} dataserie.",
	"fr-FR": "Combinaisons de données avec {numSeries} séries de données.",
	"es-ES": "Gráfico combinado con {numSeries} series de datos.",
	"it-IT": "Grafico a combinazione con {numSeries} serie di dati.",
	"nl-NL": "Combinatiediagram met {numSeries} datareeks.",
	"pt-BR": "",
	"fi-FI": "Yhdistelmäkaavio, jossa {numSeries} arvosarjaa.",
	"ja-JP": "データ系列の数が{numSeries}個の複合グラフ。",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_DEFAULT_SINGLE
const chartTypesDefaultSingle = {
	"en-US": "Chart with {numPoints} data points.",
	"en-GB": "Chart with {numPoints} data {#plural(numPoints, points, point)}.",
	"da-DK": "Diagram med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"sv-SE": "Diagram med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"de-DE": "Diagramm mit {numPoints} {#plural(numPoints, Datenpunkten, Datenpunkt)}.",
	"nb-NO": "Diagram med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"fr-FR": "Graphique avec {numPoints} {#plural(numPoints, points, point)} de données.",
	"es-ES": "Gráfico con {numPoints} {#plural(numPoints, puntos, punto)} de datos.",
	"it-IT": "Grafico con {numPoints} {#plural(numPoints, punti, punto)} dati.",
	"nl-NL": "Grafiek met {numPoints} {#plural(numPoints, datapunten, datapunt)}.",
	"pt-BR": "",
	"fi-FI": "Kaavio, jossa {numPoints} {#plural(numPoints, datapistettä, datapiste)}.",
	"ja-JP": "データ{#plural(numPoints, ポイント, ポイント)}の数が{numPoints}個のグラフ。",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_DEFAULT_MULTIPLE
const chartTypesDefaultMultiple = {
	"en-US": "Chart with {numSeries} data series.",
	"en-GB": "Chart with {numSeries} data series.",
	"da-DK": "Diagram med {numSeries} dataserier.",
	"sv-SE": "Diagram med {numSeries} dataserier.",
	"de-DE": "Diagramm mit {numSeries} Datenreihen.",
	"nb-NO": "Diagram med dataserie {numSeries}.",
	"fr-FR": "Graphique avec {numSeries} séries de données.",
	"es-ES": "Gráfico con {numSeries} series de datos.",
	"it-IT": "Grafico con {numSeries} serie di dati.",
	"nl-NL": "Grafiek met {numSeries} datareeks.",
	"pt-BR": "",
	"fi-FI": "Kaavio, jossa {numSeries} arvosarjaa.",
	"ja-JP": "データ系列の数が{numSeries}個のグラフ。",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_SPLINE_SINGLE
const chartTypesSplineSingle = {
	"en-US": "Line chart with {numPoints} data points.",
	"en-GB": "Line chart with {numPoints} data {#plural(numPoints, points, point)}.",
	"da-DK": "Kurvediagram med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"sv-SE": "Linjediagram med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"de-DE": "Liniendiagramm mit {numPoints} {#plural(numPoints, Datenpunkten, Datenpunkt)}.",
	"nb-NO": "Linjediagram med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"fr-FR": "Diagramme linéaire avec {numPoints} {#plural(numPoints, points, point)} de données.",
	"es-ES": "Gráfico de líneas con {numPoints} {#plural(numPoints, puntos, punto)} de datos.",
	"it-IT": "Grafico a linee con {numPoints} {#plural(numPoints, punti, punto)} dati.",
	"nl-NL": "Lijndiagram met {numPoints} {#plural(numPoints, datapunten, datapunt)}.",
	"pt-BR": "",
	"fi-FI": "Viivakaavio, jossa {numPoints} {#plural(numPoints, datapistettä, datapiste)}.",
	"ja-JP": "データ{#plural(numPoints, ポイント, ポイント)}の数が{numPoints}個の折れ線グラフ。",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_SPLINE_MULTIPLE
const chartTypesSplineMultiple = {
	"en-US": "Line chart with {numSeries} lines.",
	"en-GB": "Line chart with {numSeries} lines.",
	"da-DK": "Kurvediagram med {numSeries} kurver.",
	"sv-SE": "Linjediagram med {numSeries} rader.",
	"de-DE": "Liniendiagramm mit {numSeries} Linien.",
	"nb-NO": "Linjediagram med {numSeries} linjer.",
	"fr-FR": "Diagramme linéaire avec {numSeries} lignes.",
	"es-ES": "Gráfico de líneas con {numSeries} líneas.",
	"it-IT": "Grafico a linee con {numSeries} linee.",
	"nl-NL": "Lijndiagram met {numSeries} lijnen.",
	"pt-BR": "",
	"fi-FI": "Viivakaavio, jossa {numSeries} riviä.",
	"ja-JP": "線の数が{numSeries}本の折れ線グラフ。",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_LINE_SINGLE
const chartTypesLineSingle = {
	"en-US": "Line chart with {numPoints} data points.",
	"en-GB": "Line chart with {numPoints} data {#plural(numPoints, points, point)}.",
	"da-DK": "Kurvediagram med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"sv-SE": "Linjediagram med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"de-DE": "Liniendiagramm mit {numPoints} {#plural(numPoints, Datenpunkten, Datenpunkt)}.",
	"nb-NO": "Linjediagram med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"fr-FR": "Diagramme linéaire avec {numPoints} {#plural(numPoints, points, point)} de données.",
	"es-ES": "Gráfico de líneas con {numPoints} {#plural(numPoints, puntos, punto)} de datos.",
	"it-IT": "Grafico a linee con {numPoints} {#plural(numPoints, punti, punto)} dati.",
	"nl-NL": "Lijndiagram met {numPoints} {#plural(numPoints, datapunten, datapunt)}.",
	"pt-BR": "",
	"fi-FI": "Viivakaavio, jossa {numPoints} {#plural(numPoints, datapistettä, datapiste)}.",
	"ja-JP": "データ{#plural(numPoints, ポイント, ポイント)}の数が{numPoints}個の折れ線グラフ。",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_LINE_MULTIPLE
const chartTypesLineMultiple = {
	"en-US": "Line chart with {numSeries} lines.",
	"en-GB": "Line chart with {numSeries} lines.",
	"da-DK": "Kurvediagram med {numSeries} kurver.",
	"sv-SE": "Linjediagram med {numSeries} rader.",
	"de-DE": "Liniendiagramm mit {numSeries} Linien.",
	"nb-NO": "Linjediagram med {numSeries} linjer.",
	"fr-FR": "Diagramme linéaire avec {numSeries} lignes.",
	"es-ES": "Gráfico de líneas con {numSeries} líneas.",
	"it-IT": "Grafico a linee con {numSeries} linee.",
	"nl-NL": "Lijndiagram met {numSeries} lijnen.",
	"pt-BR": "",
	"fi-FI": "Viivakaavio, jossa {numSeries} riviä.",
	"ja-JP": "線の数が{numSeries}本の折れ線グラフ。",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_COLUMN_SINGLE
const chartTypesColumnSingle = {
	"en-US": "Bar chart with {numPoints} {#plural(numPoints, bars, bar)}.",
	"en-GB": "Bar chart with {numPoints} {#plural(numPoints, bars, bar)}.",
	"da-DK": "Søjlediagram med {numPoints}{#plural(numPoints, søjler, søjle)}.",
	"sv-SE": "Stapeldiagram med {numPoints} {#plural(numPoints, staplar, stapel)}.",
	"de-DE": "Balkendiagramm mit {numPoints} {#plural(numPoints, Balken, Balken)}.",
	"nb-NO": "Stolpediagram med {numPoints} {#plural(numPoints, stolper, stolpe)}.",
	"fr-FR": "Diagramme à barres avec {numPoints} {#plural(numPoints, barres, barre)}.",
	"es-ES": "Gráfico de barras con {numPoints} {#plural(numPoints, barras, barra)}.",
	"it-IT": "Grafico a barre con {numPoints} {#plural(numPoints, barre, barra)}.",
	"nl-NL": "Staafdiagram met {numPoints} {#plural(numPoints, staven, staaf)}.",
	"pt-BR": "",
	"fi-FI": "Pylväskaavio, jossa {numPoints} {#plural(numPoints, pylvästä, pylväs)}.",
	"ja-JP": "{#plural(numPoints, 棒, 棒)}の数が{numPoints}本の棒グラフ。",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_COLUMN_MULTIPLE
const chartTypesColumnMultiple = {
	"en-US": "Bar chart with {numSeries} data series.",
	"en-GB": "Bar chart with {numSeries} data series.",
	"da-DK": "Søjlediagram med {numSeries} dataserier.",
	"sv-SE": "Stapeldiagram med {numSeries} dataserier.",
	"de-DE": "Balkendiagramm mit {numSeries} Datenreihen.",
	"nb-NO": "Stolpediagram med dataserie {numSeries}.",
	"fr-FR": "Diagramme à barres avec {numSeries} séries de données.",
	"es-ES": "Gráfico de barras con {numSeries} series de datos.",
	"it-IT": "Grafico a barre con {numSeries} serie di dati.",
	"nl-NL": "Staafdiagram met {numSeries} datareeks.",
	"pt-BR": "",
	"fi-FI": "Pylväskaavio, jossa {numSeries} arvosarjaa.",
	"ja-JP": "データ系列の数が{numSeries}個の棒グラフ。",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_BAR_SINGLE
const chartTypesBarSingle = {
	"en-US": "Bar chart with {numPoints} {#plural(numPoints, bars, bar)}.",
	"en-GB": "Bar chart with {numPoints} {#plural(numPoints, bars, bar)}.",
	"da-DK": "Søjlediagram med {numPoints}{#plural(numPoints, søjler, søjle)}.",
	"sv-SE": "Stapeldiagram med {numPoints} {#plural(numPoints, staplar, stapel)}.",
	"de-DE": "Balkendiagramm mit {numPoints} {#plural(numPoints, Balken, Balken)}.",
	"nb-NO": "Stolpediagram med {numPoints} {#plural(numPoints, stolper, stolpe)}.",
	"fr-FR": "Diagramme à barres avec {numPoints} {#plural(numPoints, barres, barre)}.",
	"es-ES": "Gráfico de barras con {numPoints} {#plural(numPoints, barras, barra)}.",
	"it-IT": "Grafico a barre con {numPoints} {#plural(numPoints, barre, barra)}.",
	"nl-NL": "Staafdiagram met {numPoints} {#plural(numPoints, staven, staaf)}.",
	"pt-BR": "",
	"fi-FI": "Pylväskaavio, jossa {numPoints} {#plural(numPoints, pylvästä, pylväs)}.",
	"ja-JP": "{#plural(numPoints, 棒, 棒)}の数が{numPoints}本の棒グラフ。",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_BAR_MULTIPLE
const chartTypesBarMultiple = {
	"en-US": "Bar chart with {numSeries} data series.",
	"en-GB": "Bar chart with {numSeries} data series.",
	"da-DK": "Søjlediagram med {numSeries} dataserier.",
	"sv-SE": "Stapeldiagram med {numSeries} dataserier.",
	"de-DE": "Balkendiagramm mit {numSeries} Datenreihen.",
	"nb-NO": "Stolpediagram med dataserie {numSeries}.",
	"fr-FR": "Diagramme à barres avec {numSeries} séries de données.",
	"es-ES": "Gráfico de barras con {numSeries} series de datos.",
	"it-IT": "Grafico a barre con {numSeries} serie di dati.",
	"nl-NL": "Staafdiagram met {numSeries} datareeks.",
	"pt-BR": "",
	"fi-FI": "Pylväskaavio, jossa {numSeries} arvosarjaa.",
	"ja-JP": "データ系列の数が{numSeries}個の棒グラフ。",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_PIE_SINGLE
const chartTypesPieSingle = {
	"en-US": "Pie chart with {numPoints} {#plural(numPoints, slices, slice)}.",
	"en-GB": "Pie chart with {numPoints} {#plural(numPoints, slices, slice)}.",
	"da-DK": "Cirkeldiagram med {numPoints}{#plural(numPoints, udsnit, udsnit)}.",
	"sv-SE": "Cirkeldiagram med {numPoints} {#plural(numPoints, sektorer, sektor)}.",
	"de-DE": "Tortendiagramm mit {numPoints} {#plural(numPoints, Teilen, Teil)}.",
	"nb-NO": "Sektordiagram med {numPoints} {#plural(numPoints, sektorer, sektor)}.",
	"fr-FR": "Diagramme circulaire avec {numPoints} {#plural(numPoints, tranches, tranche)}.",
	"es-ES": "Gráfico circular con {numPoints} {#plural(numPoints, cortes, corte)}.",
	"it-IT": "Grafico a torta con {numPoints} {#plural(numPoints, sezioni, sezione)}.",
	"nl-NL": "Cirkeldiagram met {numPoints} {#plural(numPoints, sneetjes, snee)}.",
	"pt-BR": "",
	"fi-FI": "Ympyräkaavio, jossa {numPoints} {#plural(numPoints, sektoria, sektori)}.",
	"ja-JP": "{#plural(numPoints, スライス, スライス)}の数が{numPoints}個の円グラフ",
};

// Location: FANCY_CHART
// Name: CHART_TYPES_PIE_MULTIPLE
const chartTypesPieMultiple = {
	"en-US": "Pie chart with {numSeries} slices.",
	"en-GB": "Pie chart with {numSeries} slices.",
	"da-DK": "Cirkeldiagram med {numSeries} udsnit.",
	"sv-SE": "Cirkeldiagram med {numSeries} sektorer.",
	"de-DE": "Tortendiagramm mit {numSeries} Tortenstücken.",
	"nb-NO": "Sektordiagram med {numSeries} sektorer.",
	"fr-FR": "Graphique circulaire avec {numSeries} secteurs.",
	"es-ES": "Gráfico circular con {numSeries} secciones.",
	"it-IT": "Grafico a torta con {numSeries} sezioni.",
	"nl-NL": "Cirkeldiagram met {numSeries} sneetjes.",
	"pt-BR": "",
	"fi-FI": "Ympyräkaavio, jossa {numSeries} ympyrää.",
	"ja-JP": "円の数が{numSeries}個の円グラフ。",
};

// Location: FANCY_CHART
// Name: X_AXIS_DESCRIPTION_SINGULAR
const chartXAxisDescriptionSingular = {
	"en-US": "X axis that shows {names[0]}.",
	"en-GB": "X axis that shows {names[0]}.",
	"da-DK": "X-akse, der viser {names[0]}.",
	"sv-SE": "X-axel som visar {names[0]}.",
	"de-DE": "X-Achse, die {names[0]} zeigt.",
	"nb-NO": "X-akse som viser {names[0]}.",
	"fr-FR": "Axe des X qui montre {names[0]}.",
	"es-ES": "Eje X que muestra {names[0]}.",
	"it-IT": "Asse X che mostra {names[0]}.",
	"nl-NL": "X-as die {names[0]} weergeeft.",
	"pt-BR": "",
	"fi-FI": "X-akseli, jossa näkyy {names[0]}.",
	"ja-JP": "{names[0]}を示すX軸。",
};

// Location: FANCY_CHART
// Name: X_AXIS_DESCRIPTION_PLURAL
const chartXAxisDescriptionPlural = {
	"en-US": "The chart has {numAxes} X axes that show {#each(names, -1) }and {names[-1]}",
	"en-GB": "The chart has {numAxes} X axes that show {#each(names, -1) }and {names[-1]}",
	"da-DK": "Diagrammet har {numAxes} X-akser, som viser {#each(names, -1) }og {names[-1]}",
	"sv-SE": "Diagrammet har {numAxes} X-axlar som visar {#each(names, -1) }och {names[-1]}",
	"de-DE":
		"Das Diagramm hat {numAxes} X-Achsen, auf der {#each(names, -1) } und {names[-1]} zu sehen sind.",
	"nb-NO": "Diagrammet har {numAxes} X-akser som viser {#each(names, -1) } og {names[-1]}.",
	"fr-FR": "Le graphique possède {numAxes} axes X affichant {#each(names, -1) } et {names[-1]}",
	"es-ES": "El gráfico tiene {numAxes} ejes X que muestran {#each(names, -1) }y {names[-1]}",
	"it-IT": "Il grafico presenta {numAxes} assi X che visualizzano {#each(names, -1) }e {names[-1]}",
	"nl-NL": "Het diagram heeft {numAxes} X-assen die {#each (names, -1)} en {names [-1]} weergeven",
	"pt-BR": "",
	"fi-FI": "Kaaviossa on {numAxes} X-akselia, joissa näkyy {#each(names, -1) } ja {names[-1]}",
	"ja-JP":
		"チャートには {numAxes} がある。 X軸は{#each(names, -1) }と{names[-1]}を表示しています。",
};

// Location: FANCY_CHART
// Name: CATEGORY_COLUMN_HEADER
const chartCategoryColumnHeader = {
	"en-US": "Category",
	"en-GB": "Category",
	"da-DK": "Kategori",
	"sv-SE": "Kategori",
	"de-DE": "Kategorie",
	"nb-NO": "Kategori",
	"fr-FR": "Catégorie",
	"es-ES": "Categoría",
	"it-IT": "Categoria",
	"nl-NL": "Categorie",
	"pt-BR": "",
	"fi-FI": "Luokka",
	"ja-JP": "カテゴリー",
};

// Location: FANCY_CHART
// Name: DATETIME_COLUMN_HEADER
const chartDatetimeColumnHeader = {
	"en-US": "Date and/or time",
	"en-GB": "Date and/or time",
	"da-DK": "Dato og/eller klokkeslæt",
	"sv-SE": "Datum och/eller tid",
	"de-DE": "Datum und/oder Uhrzeit",
	"nb-NO": "Dato og/eller klokkeslett",
	"fr-FR": "Date et/ou heure",
	"es-ES": "Fecha u hora",
	"it-IT": "Data e/o ora",
	"nl-NL": "Datum en/of tijd",
	"pt-BR": "",
	"fi-FI": "Päivämäärä ja/tai aika",
	"ja-JP": "日時",
};

// Location: FANCY_CHART
// Name: Y_AXIS_DESCRIPTION_SINGULAR
const chartYAxisDescriptionSingular = {
	"en-US": "Y axis that shows {names[0]}.",
	"en-GB": "Y axis that shows {names[0]}.",
	"da-DK": "Y-akse, der viser {names[0]}.",
	"sv-SE": "Y-axel som visar {names[0]}.",
	"de-DE": "Y-Achse, die {names[0]} zeigt.",
	"nb-NO": "Y-akse som viser {names[0]}.",
	"fr-FR": "Axe des Y qui montre {names[0]}.",
	"es-ES": "Eje Y que muestra {names[0]}.",
	"it-IT": "Asse Y che mostra {names[0]}.",
	"nl-NL": "Y-as die {names[0]} weergeeft.",
	"pt-BR": "",
	"fi-FI": "Y-akseli, jossa näkyy {names[0]}.",
	"ja-JP": "{names[0]}を示すY軸。",
};

// Location: FANCY_CHART
// Name: Y_AXIS_DESCRIPTION_PLURAL
const chartYAxisDescriptionPlural = {
	"en-US": "The chart has {numAxes} Y axes that show {#each(names, -1) }and {names[-1]}",
	"en-GB": "The chart has {numAxes} Y axes that show {#each(names, -1) }and {names[-1]}",
	"da-DK": "Diagrammet har {numAxes} Y-akser, som viser {#each(names, -1) }og {names[-1]}",
	"sv-SE": "Diagrammet har {numAxes} Y-axlar som visar {#each(names, -1) }och {names[-1]}",
	"de-DE":
		"Das Diagramm hat {numAxes} Y-Achsen, auf der {#each(names, -1) } und {names[-1]} zu sehen sind.",
	"nb-NO": "Diagrammet har {numAxes} Y-akser som viser {#each(names, -1) } og {names[-1]}.",
	"fr-FR": "Le graphique possède {numAxes} axes Y affichant {#each(names, -1) } et {names[-1]}",
	"es-ES": "El gráfico tiene {numAxes} ejes Y que muestran {#each(names, -1) }y {names[-1]}",
	"it-IT": "Il grafico presenta {numAxes} assi Y che visualizzano {#each(names, -1) }e {names[-1]}",
	"nl-NL": "Het diagram heeft {numAxes} Y-assen die {#each (names, -1)} en {names [-1]} weergeven",
	"pt-BR": "",
	"fi-FI": "Kaaviossa on {numAxes} Y-akselia, joissa näkyy {#each(names, -1) } ja {names[-1]}",
	"ja-JP": "グラフには{#each(names, -1) }および{names[-1]}と表示されたY軸が{numAxes}本あります。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_DEFAULT
const chartSeriesDefault = {
	"en-US":
		"{name}, series {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}.",
	"en-GB":
		"{name}, series {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}.",
	"da-DK":
		"{name}, serie {ix} af {numSeries} med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"sv-SE":
		"{name}, serie {ix} av {numSeries} med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"de-DE":
		"{name}, Datenreihe {ix} von {numSeries} mit {numPoints} {#plural(numPoints, Datenpunkten, Datenpunkt)}.",
	"nb-NO":
		"{name}, serie {ix} av {numSeries} med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"fr-FR":
		"{name}, série {ix} sur {numSeries} avec {numPoints} {#plural(numPoints, points, point)} de données.",
	"es-ES":
		"{name}, serie {ix} de {numSeries} con {numPoints} {#plural(numPoints, puntos, punto)} de datos.",
	"it-IT":
		"{name}, serie {ix} di {numSeries} con {numPoints} {#plural(numPoints, punti, punto)} dati.",
	"nl-NL":
		"{name}, serie {ix} van {numSeries} met {numPoints} {#plural(numPoints, datapunten, datapunt)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, sarja {ix}/{numSeries}, jossa {numPoints} {#plural(numPoints, datapistettä, datapiste)}.",
	"ja-JP":
		"データ{#plural(numPoints, ポイント, ポイント)}の数が{numPoints}個の{name}（系列{ix}/{numSeries}）。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_DEFAULT_COMBINATION
const chartSeriesDefaultCombination = {
	"en-US":
		"{name}, series {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}.",
	"en-GB":
		"{name}, series {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}.",
	"da-DK":
		"{name}, serie {ix} af {numSeries} med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"sv-SE":
		"{name}, serie {ix} av {numSeries} med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"de-DE":
		"{name}, Datenreihe {ix} von {numSeries} mit {numPoints} {#plural(numPoints, Datenpunkten, Datenpunkt)}.",
	"nb-NO":
		"{name}, serie {ix} av {numSeries} med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"fr-FR":
		"{name}, série {ix} sur {numSeries} avec {numPoints} {#plural(numPoints, points, point)} de données.",
	"es-ES":
		"{name}, serie {ix} de {numSeries} con {numPoints} {#plural(numPoints, puntos, punto)} de datos.",
	"it-IT": "{name}, serie {ix} di {numSeries} con {numPoints} {#plural(numPoints, punti, punto)}.",
	"nl-NL":
		"{name}, serie {ix} van {numSeries} met {numPoints} {#plural(numPoints, datapunten, datapunt)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, sarja {ix}/{numSeries}, jossa {numPoints} {#plural(numPoints, datapistettä, datapiste)}.",
	"ja-JP":
		"データ{#plural(numPoints, ポイント, ポイント)}の数が{numPoints}個の{name}（系列{ix}/{numSeries}）。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_LINE
const chartSeriesLine = {
	"en-US":
		"{name}, line {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}.",
	"en-GB":
		"{name}, line {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}.",
	"da-DK":
		"{name}, kurve {ix} af {numSeries} med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"sv-SE":
		"{name}, linje {ix} av {numSeries} med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"de-DE":
		"{name}, Linie {ix} von {numSeries} mit {numPoints} {#plural(numPoints, Datenpunkten, Datenpunkt)}.",
	"nb-NO":
		"{name}, linje {ix} av {numSeries} med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"fr-FR":
		"{name}, ligne {ix} sur {numSeries} avec {numPoints} {#plural(numPoints, points, point)} de données.",
	"es-ES":
		"{name}, línea {ix} de {numSeries} con {numPoints} {#plural(numPoints, puntos, punto)} de datos.",
	"it-IT":
		"{name}, linea {ix} di {numSeries} con {numPoints} {#plural(numPoints, punti, punto)} dati.",
	"nl-NL":
		"{name}, lijn {ix} van {numSeries} met {numPoints} {#plural(numPoints, datapunten, datapunt)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, rivi {ix}/{numSeries}, jolla {numPoints} {#plural(numPoints, datapistettä, datapiste)}.",
	"ja-JP":
		"データ{#plural(numPoints, ポイント, ポイント)}の数が{numPoints}個の{name}（線{ix}/{numSeries}）。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_LINE_COMBINATION
const chartSeriesLineCombination = {
	"en-US":
		"{name}, series {ix} of {numSeries}. Line with {numPoints} data {#plural(numPoints, points, point)}.",
	"en-GB":
		"{name}, series {ix} of {numSeries}. Line with {numPoints} data {#plural(numPoints, points, point)}.",
	"da-DK":
		"{name}, serie {ix} af {numSeries}. Kurve med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"sv-SE":
		"{name}, serie {ix} av {numSeries}. Linje med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"de-DE":
		"{name}, Datenreihe {ix} von {numSeries}. Linie mit {numPoints} {#plural(numPoints, Datenpunkten, Datenpunkt)}.",
	"nb-NO":
		"{name}, serie {ix} av {numSeries}. Linje med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"fr-FR":
		"{name}, série {ix} sur {numSeries}. Ligne avec {numPoints} {#plural(numPoints, points, point)} de données.",
	"es-ES":
		"{name}, serie {ix} de {numSeries}. Línea con {numPoints} {#plural(numPoints, puntos de datos, punto de datos)}.",
	"it-IT":
		"{name}, serie {ix} di {numSeries}. Linea con {numPoints} {#plural(numPoints, punti dati, punto dati)}.",
	"nl-NL":
		"{name}, series {ix} of {numSeries}. Lijn met {numPoints} {#plural(numPoints, datapunten, datapunt)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, sarja {ix}/{numSeries}. Rivi, jolla {numPoints} {#plural(numPoints, datapistettä, datapiste)}.",
	"ja-JP":
		"{name}（系列{ix}/{numSeries}）。データ{#plural(numPoints, ポイント, ポイント)}の数が{numPoints}個の線。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_SPLINE
const chartSeriesSpline = {
	"en-US":
		"{name}, line {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}.",
	"en-GB":
		"{name}, line {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}.",
	"da-DK":
		"{name}, kurve {ix} af {numSeries} med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"sv-SE":
		"{name}, linje {ix} av {numSeries} med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"de-DE":
		"{name}, Linie {ix} von {numSeries} mit {numPoints} {#plural(numPoints, Datenpunkten, Datenpunkt)}.",
	"nb-NO":
		"{name}, linje {ix} av {numSeries} med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"fr-FR":
		"{name}, ligne {ix} sur {numSeries} avec {numPoints} {#plural(numPoints, points, point)} de données.",
	"es-ES":
		"{name}, línea {ix} de {numSeries} con {numPoints} {#plural(numPoints, puntos, punto)} de datos.",
	"it-IT":
		"{name}, linea {ix} di {numSeries} con {numPoints} {#plural(numPoints, punti, punto)} dati.",
	"nl-NL":
		"{name}, lijn {ix} van {numSeries} met {numPoints} {#plural(numPoints, datapunten, datapunt)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, rivi {ix}/{numSeries}, jolla {numPoints} {#plural(numPoints, datapistettä, datapiste)}.",
	"ja-JP":
		"データ{#plural(numPoints, ポイント, ポイント)}の数が{numPoints}個の{name}（線{ix}/{numSeries}）。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_SPLINE_COMBINATION
const chartSeriesSplineCombination = {
	"en-US":
		"{name}, series {ix} of {numSeries}. Line with {numPoints} data {#plural(numPoints, points, point)}.",
	"en-GB":
		"{name}, series {ix} of {numSeries}. Line with {numPoints} data {#plural(numPoints, points, point)}.",
	"da-DK":
		"{name}, serie {ix} af {numSeries}. Kurve med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"sv-SE":
		"{name}, serie {ix} av {numSeries}. Linje med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"de-DE":
		"{name}, Datenreihe {ix} von {numSeries}. Linie mit {numPoints} {#plural(numPoints, Datenpunkten, Datenpunkt)}.",
	"nb-NO":
		"{name}, serie {ix} av {numSeries}. Linje med {numPoints} {#plural(numPoints, datapunkter, datapunkt)}.",
	"fr-FR":
		"{name}, série {ix} sur {numSeries}. Ligne avec {numPoints} {#plural(numPoints, points, point)} de données.",
	"es-ES":
		"{name}, serie {ix} de {numSeries}. Línea con {numPoints} {#plural(numPoints, puntos, punto)} de datos.",
	"it-IT":
		"{name}, serie {ix} di {numSeries}. Linea con {numPoints} {#plural(numPoints, punti, punto)} dati.",
	"nl-NL":
		"{name}, series {ix} of {numSeries}. Lijn met {numPoints} {#plural(numPoints, datapunten, datapunt)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, sarja {ix}/{numSeries}. Rivi, jolla {numPoints} {#plural(numPoints, datapistettä, datapiste)}.",
	"ja-JP":
		"{name}（系列{ix}/{numSeries}）。データ{#plural(numPoints, ポイント, ポイント)}の数が{numPoints}個の線。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_COLUMN
const chartSeriesColumn = {
	"en-US":
		"{name}, bar series {ix} of {numSeries} with {numPoints} {#plural(numPoints, bars, bar)}.",
	"en-GB":
		"{name}, bar series {ix} of {numSeries} with {numPoints} {#plural(numPoints, bars, bar)}.",
	"da-DK":
		"{name}, søjleserie {ix} af {numSeries} med {numPoints} {#plural(numPoints, søjler, søjle)}.",
	"sv-SE":
		"{name}, stapelserie {ix} av {numSeries} med {numPoints} {#plural(numPoints, staplar, stapel)}.",
	"de-DE":
		"{name}, Balkenreihe {ix} von {numSeries} mit {numPoints} {#plural(numPoints, Balken, Balken)}.",
	"nb-NO":
		"{name}, stolpeserie {ix} av {numSeries} med {numPoints} {#plural(numPoints, stolper, stolpe)}.",
	"fr-FR":
		"{name}, série de barres {ix} sur {numSeries} med {numPoints} {#plural(numPoints, barres, barre)}.",
	"es-ES":
		"{name}, serie de barras {ix} de {numSeries} con {numPoints} datos {#plural(numPoints, barras, barra)}.",
	"it-IT":
		"{name}, serie a barre {ix} di {numSeries} con {numPoints} {#plural(numPoints, barre, barra)}.",
	"nl-NL":
		"{name}, staafreeks {ix} of {numSeries} met {numPoints} {#plural(numPoints, staven, staaf)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, pylvässarja {ix}/{numSeries}, jolla {numPoints} {#plural(numPoints, pylvästä, pylväs)}.",
	"ja-JP": "{#plural(numPoints, 棒, 棒)}の数が{numPoints}本の{name}（棒系列{ix}/{numSeries}）。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_COLUMN_COMBINATION
const chartSeriesColumnCombination = {
	"en-US":
		"{name}, series {ix} of {numSeries}. Bar series with {numPoints} {#plural(numPoints, bars, bar)}.",
	"en-GB":
		"{name}, series {ix} of {numSeries}. Bar series with {numPoints} {#plural(numPoints, bars, bar)}.",
	"da-DK":
		"{name}, serie {ix} af {numSeries}. Søjleserie med {numPoints} {#plural(numPoints, søjler, søjle)}.",
	"sv-SE":
		"{name}, serie {ix} av {numSeries}. Stapelserie med {numPoints} {#plural(numPoints, staplar, stapel)}.",
	"de-DE":
		"{name}, Datenreihe {ix} von {numSeries}. Balkenreihe med {numPoints} {#plural(numPoints, Balken, Balken)}.",
	"nb-NO":
		"{name}, serie {ix} av {numSeries}. Stolpeserie med {numPoints} {#plural(numPoints, stolper, stolpe)}.",
	"fr-FR":
		"{name}, série {ix} sur {numSeries}. Série de barres med {numPoints} {#plural(numPoints, barres, barre)}.",
	"es-ES":
		"{name}, serie {ix} de {numSeries}. Serie de barras con {numPoints} {#plural(numPoints, barras, barra)}.",
	"it-IT":
		"{name}, serie {ix} di {numSeries}. Serie a barre con {numPoints} {#plural(numPoints, barre, barra)}.",
	"nl-NL":
		"{name}, series {ix} of {numSeries}. Staafreeks met {numPoints} {#plural(numPoints, staven, staaf)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, sarja {ix}/{numSeries}. Pylvässarja, jossa {numPoints} {#plural(numPoints, pylvästä, pylväs)}.",
	"ja-JP":
		"{name}（系列{ix}/{numSeries}）。{#plural(numPoints, 棒, 棒)}の数が{numPoints}本の棒系列。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_BAR
const chartSeriesBar = {
	"en-US":
		"{name}, bar series {ix} of {numSeries} with {numPoints} {#plural(numPoints, bars, bar)}.",
	"en-GB":
		"{name}, bar series {ix} of {numSeries} with {numPoints} {#plural(numPoints, bars, bar)}.",
	"da-DK":
		"{name}, søjleserie {ix} af {numSeries} med {numPoints} {#plural(numPoints, søjler, søjle)}.",
	"sv-SE":
		"{name}, stapelserie {ix} av {numSeries} med {numPoints} {#plural(numPoints, staplar, stapel)}.",
	"de-DE":
		"{name}, Balkenreihe {ix} von {numSeries} mit {numPoints} {#plural(numPoints, Balken, Balken)}.",
	"nb-NO":
		"{name}, stolpeserie {ix} av {numSeries} med {numPoints} {#plural(numPoints, stolper, stolpe)}.",
	"fr-FR":
		"{name}, série de barres {ix} sur {numSeries} avec {numPoints} {#plural(numPoints, barres, barre)}.",
	"es-ES":
		"{name}, serie de barras {ix} de {numSeries} con {numPoints} datos {#plural(numPoints, barras, barra)}.",
	"it-IT":
		"{name}, serie a barre {ix} di {numSeries} con {numPoints} {#plural(numPoints, barre, barra)}.",
	"nl-NL":
		"{name}, staafreeks {ix} of {numSeries} met {numPoints} {#plural(numPoints, staven, staaf)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, pylvässarja {ix}/{numSeries}, jolla {numPoints} {#plural(numPoints, pylvästä, pylväs)}.",
	"ja-JP": "{#plural(numPoints, 棒, 棒)}の数が{numPoints}本の{name}（棒系列{ix}/{numSeries}）。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_BAR_COMBINATION
const chartSeriesBarCombination = {
	"en-US":
		"{name}, series {ix} of {numSeries}. Bar series with {numPoints} {#plural(numPoints, bars, bar)}.",
	"en-GB":
		"{name}, series {ix} of {numSeries}. Bar series with {numPoints} {#plural(numPoints, bars, bar)}.",
	"da-DK":
		"{name}, serie {ix} af {numSeries}. Søjleserie med {numPoints} {#plural(numPoints, søjler, søjle)}.",
	"sv-SE":
		"{name}, serie {ix} av {numSeries}. Stapelserie med {numPoints} {#plural(numPoints, staplar, stapel)}.",
	"de-DE":
		"{name}, Datenreihe {ix} von {numSeries}. Balkenreihe mit {numPoints} {#plural(numPoints, Balken, Balken)}.",
	"nb-NO":
		"{name}, serie {ix} av {numSeries}. Stolpeserie med {numPoints} {#plural(numPoints, stolper, stolpe)}.",
	"fr-FR":
		"{name}, série {ix} sur {numSeries}. Série de barres avec {numPoints} {#plural(numPoints, barres, barre)}.",
	"es-ES":
		"{name}, serie {ix} de {numSeries}. Serie de barras con {numPoints} {#plural(numPoints, barras, barra)}.",
	"it-IT":
		"{name}, serie {ix} di {numSeries}. Serie a barre con {numPoints} {#plural(numPoints, barre, barra)}.",
	"nl-NL":
		"{name}, series {ix} of {numSeries}. Staafreeks met {numPoints} {#plural(numPoints, staven, staaf)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, sarja {ix}/{numSeries}. Pylvässarja, jossa {numPoints} {#plural(numPoints, pylvästä, pylväs)}.",
	"ja-JP":
		"{name}（系列{ix}/{numSeries}）。{#plural(numPoints, 棒, 棒)}の数が{numPoints}本の棒系列。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_PIE
const chartSeriesPie = {
	"en-US": "{name}, pie {ix} of {numSeries} with {numPoints} {#plural(numPoints, slices, slice)}.",
	"en-GB": "{name}, pie {ix} of {numSeries} with {numPoints} {#plural(numPoints, slices, slice)}.",
	"da-DK":
		"{name}, cirkeludsnit {ix} af {numSeries} med {numPoints} {#plural(numPoints, udsnit, udsnit)}.",
	"sv-SE":
		"{name}, cirkel {ix} av {numSeries} med {numPoints}{#plural(numPoints, sektorer, sektor)}.",
	"de-DE":
		"{name}, Tortenstück {ix} von {numSeries} mit {numPoints} {#plural(numPoints, Teilen, Teil)}.",
	"nb-NO":
		"{name}, sektor {ix} av {numSeries} med {numPoints} {#plural(numPoints, sektorer, sektor)}.",
	"fr-FR":
		"{name}, secteur {ix} sur {numSeries} avec {numPoints} {#plural(numPoints, tranches, tranche)}.",
	"es-ES":
		"{name}, sección {ix} de {numSeries} con {numPoints} {#plural(numPoints, cortes, corte)}.",
	"it-IT":
		"{name}, torta {ix} di {numSeries} con {numPoints} {#plural(numPoints, sezioni, sezione)}.",
	"nl-NL": "{name}, pie {ix} van {numSeries} met {numPoints} {#plural(numPoints, sneetjes, snee)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, ympyrä {ix}/{numSeries}, jossa {numPoints} {#plural(numPoints, sektoria, sektori)}.",
	"ja-JP":
		"{#plural(numPoints, スライス, スライス)}の数が{numPoints}個の{name}（円{ix}/{numSeries}）。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_SCATTER_COMBINATION
const chartSeriesScatterCombination = {
	"en-US":
		"{name}, series {ix} of {numSeries}, scatter plot with {numPoints} {#plural(numPoints, points, point)}.",
	"en-GB":
		"{name}, series {ix} of {numSeries}, scatter plot with {numPoints} {#plural(numPoints, points, point)}.",
	"da-DK":
		"{name}, serie {ix} af {numSeries}, punktdiagram med {numPoints} {#plural(numPoints, punkter, punkt)}.",
	"sv-SE":
		"{name}, serie {ix} av {numSeries}, punktdiagram med {numPoints} {#plural(numPoints, punkter, punkt)}.",
	"de-DE":
		"{name}, Datenreihe {ix} von {numSeries}, Streudiagramm mit {numPoints} {#plural(numPoints, Punkten, Punkt)}.",
	"nb-NO":
		"{name}, serie {ix} av {numSeries}, punktdiagram med {numPoints} {#plural(numPoints, punkter, punkt)}.",
	"fr-FR":
		"{name}, série {ix} sur {numSeries}, graphique en nuage avec {numPoints}{#plural(numPoints, points, point)}.",
	"es-ES":
		"{name}, serie {ix} de {numSeries}, diagrama de dispersión con {numPoints} {#plural(numPoints, puntos, punto)}.",
	"it-IT":
		"{name}, serie {ix} di {numSeries}, grafico a dispersione con {numPoints} {#plural(numPoints, punti, punto)}.",
	"nl-NL":
		"{name}, series {ix} of {numSeries}, spreidingsdiagram met {numPoints} {#plural(numPoints, punten, punt)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, sarja {ix}/{numSeries}, pistekaavio, jossa {numPoints} {#plural(numPoints, pistettä, piste)}.",
	"ja-JP":
		"{#plural(numPoints, ポイント, ポイント)}の数が{numPoints}個の{name}散布図（系列{ix}/{numSeries}）。",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_MAP_COMBINATION
const chartSeriesMapCombination = {
	"en-US":
		"{name}, series {ix} of {numSeries}. Map with {numPoints} {#plural(numPoints, areas, area)}.",
	"en-GB":
		"{name}, series {ix} of {numSeries}. Map with {numPoints} {#plural(numPoints, areas, area)}.",
	"da-DK":
		"{name}, serie {ix} af {numSeries}. Kort med {numPoints} {#plural(numPoints, områder, område)}.",
	"sv-SE":
		"{name}, serie {ix} av {numSeries}. Karta med {numPoints}{#plural(numPoints, områden, område)}.",
	"de-DE":
		"{name}, Datenreihe {ix} von {numSeries}. Abbildung mit {numPoints} {#plural(numPoints, Feldern, Feld)}.",
	"nb-NO":
		"{name}, serie {ix} av {numSeries}. Kart med {numPoints} {#plural(numPoints, områder, område)}.",
	"fr-FR":
		"{name}, série {ix} sur {numSeries}. Carte avec {numPoints} {#plural(numPoints, zones, zone)}.",
	"es-ES":
		"{name}, serie {ix} de {numSeries}. Mapa con {numPoints} {#plural(numPoints, áreas, área)}.",
	"it-IT":
		"{name}, serie {ix} di {numSeries}. Mappa con {numPoints} {#plural(numPoints, aree, area)}.",
	"nl-NL":
		"{name}, series {ix} of {numSeries}. Kaart met {numPoints} {#plural(numPoints, gebieden, gebied)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, sarja {ix}/{numSeries}. Kartta, jossa {numPoints} {#plural(numPoints, aluetta, alue)}.",
	"ja-JP":
		"{name}（系列{ix}/{numSeries}）。{#plural(numPoints, エリア, エリア)}の数が{numPoints}個のマップ",
};

// Location: FANCY_CHART
// Name: CHART_SERIES_MAPBUBBLE_COMBINATION
const chartSeriesMapbubbleCombination = {
	"en-US":
		"{name}, series {ix} of {numSeries}. Bubble series with {numPoints} {#plural(numPoints, bubbles, bubble)}.",
	"en-GB":
		"{name}, series {ix} of {numSeries}. Bubble series with {numPoints} {#plural(numPoints, bubbles, bubble)}.",
	"da-DK":
		"{name}, serie {ix} af {numSeries}. Bobleserie med {numPoints} {#plural(numPoints, bobler, boble)}.",
	"sv-SE":
		"{name}, serie {ix} av {numSeries}. Bubbelserie med {numPoints} {#plural(numPoints, bubblor, bubbla)}.",
	"de-DE":
		"{name}, Datenreihe {ix} von {numSeries}. Blasenreihe mit {numPoints} {#plural(numPoints, Blasen, Blase)}.",
	"nb-NO":
		"{name}, serie {ix} av {numSeries}. Bobleserie med {numPoints} {#plural(numPoints, bobler, boble)}.",
	"fr-FR":
		"{name}, série {ix} sur {numSeries}. Série de bulles avec {numPoints} {#plural(numPoints, bulles, bulle)}.",
	"es-ES":
		"{name}, serie {ix} de {numSeries}. Serie de burbujas con {numPoints} {#plural(numPoints, burbujas, burbuja)}.",
	"it-IT":
		"{name}, serie {ix} di {numSeries}. Serie a bolle con {numPoints} {#plural(numPoints, bolle, bolla)}.",
	"nl-NL":
		"{name}, series {ix} of {numSeries}. Bubbelreeks met {numPoints} {#plural(numPoints, bubbels, bubbel)}.",
	"pt-BR": "",
	"fi-FI":
		"{name}, sarja {ix}/{numSeries}. Kuplasarja, jossa {numPoints} {#plural(numPoints, kuplaa, kupla)}.",
	"ja-JP":
		"{name}（系列{ix}/{numSeries}）。{#plural(numPoints, バブル, バブル)}の数が{numPoints}個のバブル系列。",
};

// Location: FANCY_CHART
// Name: X_AXIS_DESCRIPTION
const chartXAxisDescription = {
	"en-US": "X axis, {name}",
	"en-GB": "X axis, {name}",
	"da-DK": "X-akse, {name}",
	"sv-SE": "X-axel, {name}",
	"de-DE": "X-Achse, {name}",
	"nb-NO": "X-akse, {name}",
	"fr-FR": "Axe des X, {name}",
	"es-ES": "Eje X, {name}",
	"it-IT": "Asse X, {name}",
	"nl-NL": "X-as, {name}",
	"pt-BR": "",
	"fi-FI": "X-akseli, {name}",
	"ja-JP": "X軸、{name}",
};

// Location: FANCY_CHART
// Name: Y_AXIS_DESCRIPTION
const chartYAxisDescription = {
	"en-US": "Y axis, {name}",
	"en-GB": "Y axis, {name}",
	"da-DK": "Y-akse, {name}",
	"sv-SE": "Y-axel, {name}",
	"de-DE": "Y-Achse, {name}",
	"nb-NO": "Y-akse, {name}",
	"fr-FR": "Axe des Y, {name}",
	"es-ES": "Eje Y, {name}",
	"it-IT": "Asse Y, {name}",
	"nl-NL": "Y-as, {name}",
	"pt-BR": "",
	"fi-FI": "Y-akseli, {name}",
	"ja-JP": "Y軸、{name}",
};

// Location: FANCY_CHART
// Name: CONTEXT_MENU_FOR_LABEL
const chartContextMenuForLabel = {
	"en-US": "Context menu for",
	"en-GB": "Context menu for",
	"da-DK": "Genvejsmenu til",
	"sv-SE": "Snabbmeny för",
	"de-DE": "Kontextmenü für",
	"nb-NO": "Kontekstmeny for",
	"fr-FR": "Menu contextuel pour",
	"es-ES": "Menú contextual para",
	"it-IT": "Menu contestuale per",
	"nl-NL": "Contextmenu voor",
	"pt-BR": "",
	"fi-FI": "Pikavalikko,",
	"ja-JP": "コンテキストメニューの対象",
};

// Location: FANCY_CHART
// Name: CONTEXT_MENU_ENHANCED_CONTRAST_LABEL
const chartContextMenuEnhancedContrastLabel = {
	"en-US": "Enhanced contrast",
	"en-GB": "Enhanced contrast",
	"da-DK": "Forbedret kontrast",
	"sv-SE": "Förbättrad kontrast",
	"de-DE": "Erhöhter Kontrast",
	"nb-NO": "Forbedret kontrast",
	"fr-FR": "Contraste amélioré",
	"es-ES": "Contraste mejorado",
	"it-IT": "Contrasto ottimizzato",
	"nl-NL": "Verbeterd contrast",
	"pt-BR": "",
	"fi-FI": "Parannettu kontrasti",
	"ja-JP": "コントラストの強調",
};

// Location: FANCY_CHART
// Name: CONTEXT_MENU_ENHANCED_CONTRAST_TOOLTIP
const chartContextMenuEnhancedContrastTooltip = {
	"en-US": "Makes series more clear by introducing patterns and other visual aids.",
	"en-GB": "Makes series more clear by introducing patterns and other visual aids.",
	"da-DK": "Gør serien tydeligere ved at introducere mønstre og andre visuelle hjælpemidler.",
	"sv-SE": "Gör serier tydligare genom att applicera mönster och andra visuella hjälpmedel.",
	"de-DE":
		"Damit können Datenreihen durch Muster und andere visuelle Hilfsmittel klarer dargestellt werden.",
	"nb-NO": "Gjør serier tydeligere ved hjelp av mønstre og andre visuelle hjelpemidler.",
	"fr-FR": "Rend les séries plus claires en introduisant des motifs et d'autres aides visuelles.",
	"es-ES": "Hace que las series sean más claras al introducir patrones y otras ayudas visuales.",
	"it-IT": "Rende le serie più chiare introducendo modelli e altri aiuti visivi.",
	"nl-NL":
		"Verbeterd contrast maakt series duidelijker door patronen en andere visuele hulpmiddelen te introduceren.",
	"pt-BR": "",
	"fi-FI": "Tee sarjoista selkeämpiä käyttämällä kuvioita ja muita visuaalisia apuvälineitä.",
	"ja-JP": "パターンなどの視覚的な支援を導入することで、連続性がより明瞭になります。",
};

// Location: FANCY_CHART
// Name: CONTEXT_MENU_TABLE_VIEW_LABEL
const chartContextMenuTableViewLabel = {
	"en-US": "Open table data view",
	"en-GB": "Open table data view",
	"da-DK": "Åbn tabeldatavisning",
	"sv-SE": "Öppna tabelldatavyn",
	"de-DE": "Tabellendatenansicht öffnen",
	"nb-NO": "Åpne tabelldatavisning",
	"fr-FR": "Ouvrir la vue des données du tableau",
	"es-ES": "Abrir vista de datos de tabla",
	"it-IT": "Apri la visualizzazione dati tabella",
	"nl-NL": "Open tabeldata weergave",
	"pt-BR": "",
	"fi-FI": "Avaa taulukkotietonäkymä",
	"ja-JP": "テーブルデータビューを開く",
};

// Location: FANCY_CHART
// Name: CONTEXT_MENU_TABLE_VIEW_TOOLTIP
const chartContextMenuTableViewTooltip = {
	"en-US": "The table data view allows you to view the data in a table format.",
	"en-GB": "The table data view allows you to view the data in a table format.",
	"da-DK": "Tabeldatavisningen giver dig mulighed for at se dataene i et tabelformat.",
	"sv-SE": "Med tabelldatavyn kan du visa data i ett tabellformat.",
	"de-DE": "Die Tabellendatenansicht ermöglicht die Anzeige der Daten in einem Tabellenformat.",
	"nb-NO": "Tabelldatavisningen lar deg vise dataene i et tabellformat.",
	"fr-FR":
		"La vue des données du tableau vous permet d'afficher les données sous forme de tableau.",
	"es-ES": "La vista de datos de tabla le permite ver los datos en formato de tabla.",
	"it-IT": "La visualizzazione dati tabella consente di visualizzare i dati in formato tabella.",
	"nl-NL": "In de tabeldata weergave kun je de data in een tabelindeling weergeven.",
	"pt-BR": "",
	"fi-FI": "Taulukkotietonäkymässä voit tarkastella tietoja taulukkomuodossa.",
	"ja-JP": "テーブルデータビューでは、データをテーブル形式で表示できます。",
};

// Location: ANNOTATIONS
// Name: ANNOTATIONS_LABEL
const annotations = {
	"en-US": "Annotations:",
	"en-GB": "Annotations:",
	"da-DK": "Annotationer:",
	"sv-SE": "Noteringar:",
	"de-DE": "Annotationen:",
	"nb-NO": "Merknader:",
	"fr-FR": "Annotations :",
	"es-ES": "Anotaciones:",
	"it-IT": "Annotazioni:",
	"nl-NL": "Annotaties:",
	"pt-BR": "",
	"fi-FI": "Huomautukset:",
	"ja-JP": "アノテーション：",
};

// Location: ANNOTATIONS
// Name: NO_ANNOTATIONS_FOR_CHART
const noAnnotationsForThisChart = {
	"en-US": "No annotations for this chart.",
	"en-GB": "No annotations for this chart.",
	"da-DK": "Der er ingen annotationer til dette diagram.",
	"sv-SE": "Inga noteringar för detta diagram.",
	"de-DE": "Keine Annotationen für dieses Diagramm.",
	"nb-NO": "Ingen merknader for dette diagrammet.",
	"fr-FR": "Aucune annotation pour ce graphique.",
	"es-ES": "No hay anotaciones para este gráfico.",
	"it-IT": "Nessuna annotazione per questo grafico.",
	"nl-NL": "Geen annotaties voor deze grafiek.",
	"pt-BR": "",
	"fi-FI": "Tätä kaaviota koskevia huomautuksia ei ole.",
	"ja-JP": "このグラフにアノテーションはありません。",
};

// Location: ANNOTATIONS
// Name: CREATE_ANNOTATION_HELP_TEXT
const createAnnotationHelpText = {
	"en-US": 'Create an annotation by clicking the "New annotation" button above.',
	"en-GB": 'Create an annotation by clicking the "New annotation" button above.',
	"da-DK": 'Opret en annotation ved at klikke på knappen "Ny annotation" ovenfor.',
	"sv-SE": "Skapa en notering genom att klicka på Ny notering ovan.",
	"de-DE":
		"Erstellen Sie eine Annotation, indem Sie oben auf die Schaltfläche „Neue Annotation“ klicken.",
	"nb-NO": "Lag en merknad ved å klikke på «Ny merknad»-knappen ovenfor.",
	"fr-FR": "Créez une annotation en cliquant sur le bouton « Nouvelle annotation » ci-dessus.",
	"es-ES": "Cree una anotación haciendo clic en el botón «Nueva anotación».",
	"it-IT": 'Crea un\'annotazione facendo clic sul pulsante "Nuova annotazione" in alto.',
	"nl-NL": 'Maak een annotatie door op de knop "Nieuwe annotatie" hierboven te klikken.',
	"pt-BR": "",
	"fi-FI": "Luo huomautus napsauttamalla yllä olevaa Uusi huomautus -painiketta.",
	"ja-JP": "上記の「新規アノテーション」ボタンをクリックしてアノテーションを作成してください。",
};

// Location: ANNOTATIONS
// Name: NO_ANNOTATIONS_FOR_PERIOD
const noAnnotationsForChartPeriod = {
	"en-US": "No annotations created during this period.",
	"en-GB": "No annotations created during this period.",
	"da-DK": "Der er ikke oprettet nogen annotationer i denne periode.",
	"sv-SE": "Inga noteringar skapades under denna period.",
	"de-DE": "Keine Annotationen während dieses Zeitraums erstellt.",
	"nb-NO": "Ingen merknader ble opprettet i denne perioden.",
	"fr-FR": "Aucune annotation n'a été créée au cours de cette période.",
	"es-ES": "No se han creado anotaciones durante este período.",
	"it-IT": "Nessuna annotazione creata durante questo periodo.",
	"nl-NL": "Er zijn geen annotaties gemaakt in deze periode",
	"pt-BR": "",
	"fi-FI": "Tällä ajanjaksolla ei ole luotu yhtään huomautusta.",
	"ja-JP": "この期間に作成されたアノテーションはありません。",
};

// Location: ANNOTATIONS
// Name: NO_ANNOTATIONS_FOR_FAVORITE
const noAnnotationsForFavorite = {
	"en-US": "No annotations have been marked as favorite for this chart.",
	"en-GB": "No annotations have been marked as favourite for this chart.",
	"da-DK": "Der er ikke markeret nogen annotationer som favorit til dette diagram.",
	"sv-SE": "Inga noteringar har markerats som favoriter för detta diagram.",
	"de-DE": "Für dieses Diagramm wurde keine Annotation als Favorit markiert.",
	"nb-NO": "Ingen merknader har blitt merket som favoritt for dette diagrammet.",
	"fr-FR": "Aucune annotation n'a été ajoutée aux favoris pour ce graphique.",
	"es-ES": "No se han marcado anotaciones como favoritas para este gráfico.",
	"it-IT": "Nessuna annotazione è stata contrassegnata come preferita per questo grafico.",
	"nl-NL": "Er zijn geen annotaties gemarkeerd als favoriet voor deze grafiek.",
	"pt-BR": "",
	"fi-FI": "Yhtäkään huomautusta ei ole merkitty tämän kaavion suosikiksi.",
	"ja-JP": "このグラフにお気に入りとしてマークされたアノテーションはありません。",
};

// Location: ANNOTATIONS
// Name: FAVORITE_ANNOTATION_HELP_TEXT
const noAnnotationsHelpTextForFavorite = {
	"en-US": "Favorite an annotation by clicking the star to the left of it.",
	"en-GB": "Favourite an annotation by clicking the star to the left of it.",
	"da-DK": "Angiv en annotation som favorit ved at klikke på stjernen til venstre for den.",
	"sv-SE": "Markera en notering som favorit genom att klicka på stjärnan till vänster om den.",
	"de-DE":
		"Markieren Sie eine Annotation als Favorit, indem Sie auf den Stern links daneben klicken.",
	"nb-NO": "Merk en merknad som favoritt ved å klikke på stjernen til venstre for den.",
	"fr-FR": "Ajoutez une annotation à vos favoris en cliquant sur l'étoile à sa gauche.",
	"es-ES":
		"Marque como favorita una anotación haciendo clic en la estrella situada a su izquierda.",
	"it-IT": "Aggiungi un'annotazione ai preferiti facendo clic sulla stella alla sua sinistra.",
	"nl-NL": "Maak een annotatie favoriet door op de ster links ervan te klikken.",
	"pt-BR": "",
	"fi-FI": "Merkitse huomautus suosikiksi napsauttamalla sen vasemmalla puolella olevaa tähteä.",
	"ja-JP":
		"アノテーションの左側にある星マークをクリックして、アノテーションをお気に入りに登録してください。",
};

// Location: ANNOTATIONS
// Name: ANNOTATION_DATE_LABEL
const annotationsDate = {
	"en-US": "Date",
	"en-GB": "Date",
	"da-DK": "Dato",
	"sv-SE": "Datum",
	"de-DE": "Datum",
	"nb-NO": "Dato",
	"fr-FR": "Date",
	"es-ES": "Fecha",
	"it-IT": "Data",
	"nl-NL": "Datum",
	"pt-BR": "",
	"fi-FI": "Päivämäärä",
	"ja-JP": "日付",
};

// Location: ANNOTATIONS
// Name: ANNOTATION_COMMENT_LABEL
const annotationsComment = {
	"en-US": "Comment",
	"en-GB": "Comment",
	"da-DK": "Kommentar",
	"sv-SE": "Kommentar",
	"de-DE": "Kommentar",
	"nb-NO": "Kommentar",
	"fr-FR": "Commentaire",
	"es-ES": "Comentario",
	"it-IT": "Commento",
	"nl-NL": "Opmerking",
	"pt-BR": "",
	"fi-FI": "Kommentti",
	"ja-JP": "コメント",
};

// Location: ANNOTATIONS
// Name: ANNOTATION_COMMENT_LABEL
const annotationsCategory = {
	"en-US": "Category",
	"en-GB": "Category",
	"da-DK": "Kategori",
	"sv-SE": "Kategori",
	"de-DE": "Kategorie",
	"nb-NO": "Kategori",
	"fr-FR": "Catégorie",
	"es-ES": "Categoría",
	"it-IT": "Categoria",
	"nl-NL": "Categorie",
	"pt-BR": "Categoria",
	"fi-FI": "Kategoria",
	"ja-JP": "カテゴリ",
};

// Location: ANNOTATIONS
// Name: ANNOTATION_CREATED_BY_LABEL
const annotationsCreatedBy = {
	"en-US": "Created by",
	"en-GB": "Created by",
	"da-DK": "Oprettet af",
	"sv-SE": "Skapad av",
	"de-DE": "Erstellt von",
	"nb-NO": "Opprettet av",
	"fr-FR": "Créé par",
	"es-ES": "Creado por",
	"it-IT": "Creato da",
	"nl-NL": "Gemaakt door",
	"pt-BR": "",
	"fi-FI": "Luonut",
	"ja-JP": "作成者",
};

// Location: ANNOTATIONS
// Name: ANNOTATION_VISIBILITY_LABEL
const annotationsVisibility = {
	"en-US": "Visibility",
	"en-GB": "Visibility",
	"da-DK": "Synlighed",
	"sv-SE": "Synlighet",
	"de-DE": "Sichtbarkeit",
	"nb-NO": "Synlighet",
	"fr-FR": "Visibilité",
	"es-ES": "Visibilidad",
	"it-IT": "Visibilità",
	"nl-NL": "Zichtbaarheid",
	"pt-BR": "",
	"fi-FI": "Näkyvyys",
	"ja-JP": "表示",
};

// Location: ANNOTATIONS
// Name: ALL_ANNOTATIONS_LABEL
const allAnnotations = {
	"en-US": "All annotations",
	"en-GB": "All annotations",
	"da-DK": "Alle annotationer",
	"sv-SE": "Alla noteringar",
	"de-DE": "Alle Annotationen",
	"nb-NO": "Alle merknader",
	"fr-FR": "Toutes les annotations",
	"es-ES": "Todas las anotaciones",
	"it-IT": "Tutte le annotazioni",
	"nl-NL": "Alle annotaties",
	"pt-BR": "",
	"fi-FI": "Kaikki huomautukset",
	"ja-JP": "すべてのアノテーション",
};

// Location: ANNOTATIONS
// Name: CHART_PERIOD_ANNOTATIONS_LABEL
const chartPeriodAnnotations = {
	"en-US": "Chart period",
	"en-GB": "Chart period",
	"da-DK": "Diagramperiode",
	"sv-SE": "Diagram period",
	"de-DE": "Diagrammzeitraum",
	"nb-NO": "Diagramperiode",
	"fr-FR": "Période du graphique",
	"es-ES": "Período del gráfico",
	"it-IT": "Periodo del grafico",
	"nl-NL": "Grafiek periode",
	"pt-BR": "",
	"fi-FI": "Kaavion ajanjakso",
	"ja-JP": "グラフ期間",
};

// Location: ANNOTATIONS
// Name: FAVORITE_ANNOTATIONS_LABEL
const favoriteAnnotations = {
	"en-US": "Favorite annotations",
	"en-GB": "Favourite annotations",
	"da-DK": "Foretrukne annotationer",
	"sv-SE": "Favoritmarkerade noteringar",
	"de-DE": "Bevorzugte Annotationen",
	"nb-NO": "Favorittmerknader",
	"fr-FR": "Annotations ajoutées aux favoris",
	"es-ES": "Anotaciones favoritas",
	"it-IT": "Annotazioni preferite",
	"nl-NL": "Favoriete annotaties",
	"pt-BR": "",
	"fi-FI": "Suosikkihuomautukset",
	"ja-JP": "お気に入りのアノテーション",
};

// Location: ANNOTATIONS
// Name: FAVORITE_ANNOTATION_LABEL
const favoriteAnnotation = {
	"en-US": "Favorite annotation",
	"en-GB": "Favourite annotation",
	"da-DK": "Angiv annotation som favorit",
	"sv-SE": "Favoritmarkerad notering",
	"de-DE": "Bevorzugte Annotation",
	"nb-NO": "Favorittmerknad",
	"fr-FR": "Annotation ajoutée aux favoris",
	"es-ES": "Anotación favorita",
	"it-IT": "Annotazione preferita",
	"nl-NL": "Favoriete annotatie",
	"pt-BR": "",
	"fi-FI": "Suosikkihuomautus",
	"ja-JP": "アノテーションをお気に入りに登録",
};

// Location: ANNOTATIONS
// Name: FAVORITE_LABEL
const favorite = {
	"en-US": "Favorite",
	"en-GB": "Favourite",
	"da-DK": "Favorit",
	"sv-SE": "Favoriter",
	"de-DE": "Bevorzugt",
	"nb-NO": "Favoritt",
	"fr-FR": "Favoris",
	"es-ES": "Favorito",
	"it-IT": "Preferito",
	"nl-NL": "Favoriet",
	"pt-BR": "",
	"fi-FI": "Suosikki",
	"ja-JP": "お気に入りに登録",
};

// Location: ANNOTATIONS
// Name: NEW_ANNOTATION_LABEL
const newAnnotation = {
	"en-US": "Add annotation",
	"en-GB": "Add annotation",
	"da-DK": "Ny annotation",
	"sv-SE": "Ny notering",
	"de-DE": "Neue Annotation",
	"nb-NO": "Ny merknad",
	"fr-FR": "Nouvelle annotation",
	"es-ES": "Nueva anotación",
	"it-IT": "Nuova annotazione",
	"nl-NL": "Nieuwe annotatie",
	"pt-BR": "",
	"fi-FI": "Uusi huomautus",
	"ja-JP": "新しいアノテーション",
};

// Location: ANNOTATIONS
// Name: CREATE_ANNOTATION_LABEL
const createAnnotation = {
	"en-US": "Create annotation",
	"en-GB": "Create annotation",
	"da-DK": "Opret annotation",
	"sv-SE": "Skapa notering",
	"de-DE": "Annotation erstellen",
	"nb-NO": "Lag merknad",
	"fr-FR": "Créer une annotation",
	"es-ES": "Crear anotación",
	"it-IT": "Crea annotazione",
	"nl-NL": "Annotatie maken",
	"pt-BR": "",
	"fi-FI": "Luo huomautus",
	"ja-JP": "アノテーションを作成",
};

// Location: ANNOTATIONS
// Name: EDIT_ANNOTATION_LABEL
const editAnnotation = {
	"en-US": "Edit annotation",
	"en-GB": "Edit annotation",
	"da-DK": "Rediger annotation",
	"sv-SE": "Redigera notering",
	"de-DE": "Annotation bearbeiten",
	"nb-NO": "Rediger merknad",
	"fr-FR": "Modifier l'annotation",
	"es-ES": "Editar anotación",
	"it-IT": "Modifica annotazione",
	"nl-NL": "Annotatie bewerken",
	"pt-BR": "",
	"fi-FI": "Muokkaa huomautusta",
	"ja-JP": "アノテーションを編集",
};

// Location: ANNOTATIONS
// Name: SAVE_ANNOTATION_LABEL
const saveAnnotation = {
	"en-US": "Save annotation",
	"en-GB": "Save annotation",
	"da-DK": "Gem annotation",
	"sv-SE": "Spara notering",
	"de-DE": "Annotation speichern",
	"nb-NO": "Lagre merknad",
	"fr-FR": "Enregistrer l'annotation",
	"es-ES": "Guardar anotación",
	"it-IT": "Salva annotazione",
	"nl-NL": "Annotatie opslaan",
	"pt-BR": "",
	"fi-FI": "Tallenna huomautus",
	"ja-JP": "アノテーションを保存",
};

// Location: ANNOTATIONS
// Name: SHOW_ANNOTATIONS_LABEL
const showAnnotations = {
	"en-US": "View annotations",
	"en-GB": "View annotations",
	"da-DK": "Vis annotationer",
	"sv-SE": "Visa noteringar",
	"de-DE": "Annotationen anzeigen",
	"nb-NO": "Vis merknader",
	"fr-FR": "Afficher les annotations",
	"es-ES": "Mostrar anotaciones",
	"it-IT": "Mostra annotazioni",
	"nl-NL": "Annotaties weergeven",
	"pt-BR": "",
	"fi-FI": "Näytä huomautukset",
	"ja-JP": "アノテーションを表示",
};

// Location: ANNOTATIONS
// Name: SHOW_ANNOTATIONS_SR_LABEL
const showAnnotationsSrOnly = {
	"en-US": "(annotations table appears below the chart)",
	"en-GB": "(annotations table appears below the chart)",
	"da-DK": "(tabellen med annotationer vises under diagrammet)",
	"sv-SE": "(tabell med noteringar visas nedanför diagrammet)",
	"de-DE": "(Annotationen-Tabelle wird unterhalb des Diagramms angezeigt)",
	"nb-NO": "(merknader-tabellen vises under diagrammet)",
	"fr-FR": "(Le tableau des annotations s'affiche sous le graphique)",
	"es-ES": "(la tabla de anotaciones aparece debajo del gráfico)",
	"it-IT": "(la tabella Annotazioni appare sotto il grafico)",
	"nl-NL": "(annotatietabel verschijnt onder de grafiek)",
	"pt-BR": "",
	"fi-FI": "(huomautustaulukko näkyy kaavion alla)",
	"ja-JP": "(グラフの下にアノテーションテーブルが表示されます)",
};

// Location: ANNOTATIONS
// Name: EDIT_LABEL
const edit = {
	"en-US": "Edit",
	"en-GB": "Edit",
	"da-DK": "Rediger",
	"sv-SE": "Redigera",
	"de-DE": "Bearbeiten",
	"nb-NO": "Rediger",
	"fr-FR": "Modifier",
	"es-ES": "Editar",
	"it-IT": "Modifica",
	"nl-NL": "Bewerken",
	"pt-BR": "",
	"fi-FI": "Muokkaa",
	"ja-JP": "編集",
};

// Location: ANNOTATIONS
// Name: CLOSE_ANNOTATIONS_LABEL
const closeAnnotations = {
	"en-US": "Close annotations",
	"en-GB": "Close annotations",
	"da-DK": "Luk annotationer",
	"sv-SE": "Stäng noteringar",
	"de-DE": "Annotationen schließen",
	"nb-NO": "Lukk merknader",
	"fr-FR": "Fermer les annotations",
	"es-ES": "Cerrar anotaciones",
	"it-IT": "Chiudi annotazioni",
	"nl-NL": "Annotaties sluiten",
	"pt-BR": "",
	"fi-FI": "Sulje huomautukset",
	"ja-JP": "アノテーションを閉じる",
};

// Location: ANNOTATIONS
// Name: SHOW_FILTER_LABEL
const annotationsShowFilter = {
	"en-US": "Show:",
	"en-GB": "Show:",
	"da-DK": "Vis:",
	"sv-SE": "Visa:",
	"de-DE": "Zeigen:",
	"nb-NO": "Vis:",
	"fr-FR": "Afficher :",
	"es-ES": "Mostrar:",
	"it-IT": "Mostra:",
	"nl-NL": "Weergeven:",
	"pt-BR": "",
	"fi-FI": "Näytä:",
	"ja-JP": "表示：",
};

// Location: ANNOTATIONS
// Name: VISIBLE_IN_FIELD_LABEL
const annotationsVisibleInField = {
	"en-US": "Make annotation visible in",
	"en-GB": "Make annotation visible in",
	"da-DK": "Gør annotation synlig i",
	"sv-SE": "Gör noteringar synliga i",
	"de-DE": "Annotation sichtbar machen in",
	"nb-NO": "Gjør merknaden synlig i",
	"fr-FR": "Rendre l'annotation visible dans",
	"es-ES": "Hacer visible la anotación en",
	"it-IT": "Rendi visibile l'annotazione in",
	"nl-NL": "Annotatie zichtbaar maken in",
	"pt-BR": "",
	"fi-FI": "Muuta huomautus näkyväksi seuraavissa:",
	"ja-JP": "アノテーションを表示する対象",
};

// Location: ANNOTATIONS
// Name: COMMENT_FIELD_LABEL
const annotationsCommentField = {
	"en-US": "Comment",
	"en-GB": "Comment",
	"da-DK": "Kommentar",
	"sv-SE": "Kommentar",
	"de-DE": "Kommentar",
	"nb-NO": "Kommentar",
	"fr-FR": "Commentaire",
	"es-ES": "Comentario",
	"it-IT": "Commento",
	"nl-NL": "Opmerking",
	"pt-BR": "",
	"fi-FI": "Kommentti",
	"ja-JP": "コメント",
};

// Location: ANNOTATIONS
// Name: VISIBILITY_FIELD_LABEL
const annotationsVisibilityField = {
	"en-US": "Visibility",
	"en-GB": "Visibility",
	"da-DK": "Synlighed",
	"sv-SE": "Synlighet",
	"de-DE": "Sichtbarkeit",
	"nb-NO": "Synlighet",
	"fr-FR": "Visibilité",
	"es-ES": "Visibilidad",
	"it-IT": "Visibilità",
	"nl-NL": "Zichtbaarheid",
	"pt-BR": "",
	"fi-FI": "Näkyvyys",
	"ja-JP": "表示",
};

// Location: ANNOTATIONS
// Name: SYSTEM_NOTIFICATION_HELP_TEXT
const annotationsSystemNotificationHelpText = {
	"en-US": "System notification",
	"en-GB": "System notification",
	"da-DK": "Systemmeddelelse",
	"sv-SE": "Systemmeddelande",
	"de-DE": "Systembenachrichtigung",
	"nb-NO": "Systemvarsling",
	"fr-FR": "Notification système",
	"es-ES": "Notificación del sistema",
	"it-IT": "Notifica di sistema",
	"nl-NL": "Systeem notificatie",
	"pt-BR": "",
	"fi-FI": "Järjestelmän huomautus",
	"ja-JP": "システム通知",
};

// Location: APPLICATION.ANNOTATIONS
// Name: GLOBAL_TOOLTIP
const annotationsGlobalVisibilityTooltip = {
	"en-US":
		"Occasionally we'll annotate graphs to announce changes which might cause a visible spike or drop in your graphs. These annotations can be seen by all users.",
	"en-GB":
		"Occasionally we'll annotate graphs to announce changes which might cause a visible spike or drop in your graphs. These annotations can be seen by all users.",
	"da-DK":
		"Nogle gange annoterer vi grafer for at fremhæve ændringer, som kan medføre synlige udsving i dine grafer. Disse annotationer kan ses af alle brugere.",
	"sv-SE":
		"Ibland kommenterar vi diagrammen för att meddela dig om ändringar som kan orsaka en synlig topp eller dal i dina diagram. Dessa noteringar kan ses av alla användare.",
	"de-DE":
		"Manchmal fügen wir Diagrammen Anmerkungen hinzu, um zu erklären, welche Änderungen für sichtbare Anstiege oder Rückgänge verantwortlich sein könnten. Diese Anmerkungen können von allen Benutzern gesehen werden.",
	"nb-NO":
		"Fra tid til annen legger vi til merknader på diagrammer for å kunngjøre endringer som kan føre til et synlig hopp eller en synlig reduksjon i diagrammene dine. Disse merknadene kan ses av alle brukere.",
	"fr-FR":
		"Nous annoterons ponctuellement les graphiques pour vous signaler les changements susceptibles de causer un pic ou une baisse visible dans vos courbes. Ces annotations peuvent être vues par tous les utilisateurs.",
	"es-ES":
		"Ocasionalmente, agregaremos notas a los gráficos para anunciar cambios que podrían originar picos o caídas visibles. Estas anotaciones son visibles para todos los usuarios.",
	"it-IT":
		"Di volta in volta, aggiungeremo delle annotazioni ai grafici per annunciare modifiche che potrebbero causare un picco o un calo visibile nei grafici. Queste annotazioni possono essere visualizzate da tutti gli utenti.",
	"nl-NL":
		"We annoteren regelmatig grafieken om wijzigingen aan te kondigen die kunnen leiden tot een zichtbare stijging of daling in je grafieken. Deze annotaties zijn zichtbaar voor alle gebruikers.",
	"pt-BR":
		"Periodicamente, anotaremos os gráficos de modo a anunciar alterações que podem causar pico ou queda visível. Essas anotações podem ser vistas por todos os usuários.",
	"fi-FI":
		"Lisäämme toisinaan kaavioihin huomautuksia, joissa kuvataan selkeitä nousuja tai laskuja aiheuttaneita muutoksia. Kaikki käyttäjät näkevät nämä huomautukset.",
	"ja-JP":
		"当社では時折グラフにアノテーションを追加して、グラフで目に見える上昇や下降を引き起こす可能性のある変更を発表することがあります。 これらのアノテーションは、すべてのユーザーが見ることができます。",
};

// Location: ANNOTATIONS
// Name: EVERYONE_LABEL
const everyone = {
	"en-US": "Everyone",
	"en-GB": "Everyone",
	"da-DK": "Alle",
	"sv-SE": "Alla",
	"de-DE": "Alle",
	"nb-NO": "Alle",
	"fr-FR": "Tout le monde",
	"es-ES": "Todos",
	"it-IT": "Tutti",
	"nl-NL": "Iedereen",
	"pt-BR": "",
	"fi-FI": "Kaikki",
	"ja-JP": "全員",
};

// Location: ANNOTATIONS
// Name: ONLY_ME_LABEL
const onlyMe = {
	"en-US": "Only me",
	"en-GB": "Only me",
	"da-DK": "Kun mig",
	"sv-SE": "Bara jag",
	"de-DE": "Nur ich",
	"nb-NO": "Bare meg",
	"fr-FR": "Moi uniquement",
	"es-ES": "Solo yo",
	"it-IT": "Solo io",
	"nl-NL": "Alleen ik",
	"pt-BR": "",
	"fi-FI": "Vain minä",
	"ja-JP": "自分専用",
};

// Location: TABLE
// Name: SKIP_TABLE
const skipTable = {
	"en-US": "Skip table",
	"en-GB": "Skip table",
	"da-DK": "Spring tabel over",
	"sv-SE": "Hoppa över tabellen",
	"de-DE": "Tabelle überspringen",
	"nb-NO": "Hopp over tabellen",
	"fr-FR": "Ignorer le tableau",
	"es-ES": "Omitir tabla",
	"it-IT": "Ignora tabella",
	"nl-NL": "Tabel overslaan",
	"pt-BR": "",
	"fi-FI": "Ohita taulukko",
	"ja-JP": "テーブルをスキップ",
};

// Location: TABLE
// Name: TABLE_TOOLBAR
const tableToolbarLabel = {
	"en-US": "Table toolbar",
	"en-GB": "Table toolbar",
	"da-DK": "Tabelværktøjslinje",
	"sv-SE": "Verktygsfält för tabell",
	"de-DE": "Tabellen-Symbolleiste",
	"nb-NO": "Verktøylinje for tabell",
	"fr-FR": "Barre d'outils du tableau",
	"es-ES": "Barra de herramientas de tabla",
	"it-IT": "Barra degli strumenti della tabella",
	"nl-NL": "Tabel werkbalk",
	"pt-BR": "",
	"fi-FI": "Taulukon työkalupalkki",
	"ja-JP": "テーブルツールバー",
};

// Location: TABLE
// Name: TABLE_NO_DATA_STATE
const tableNoDataStateLabel = {
	"en-US": "No data to display",
	"en-GB": "No data to display",
	"da-DK": "Der er ingen data at vise",
	"sv-SE": "Inga data att visa",
	"de-DE": "Keine Daten zum Anzeigen vorhanden",
	"nb-NO": "Ingen data å vise",
	"fr-FR": "Aucune donnée à afficher",
	"es-ES": "No hay datos para mostrar",
	"it-IT": "Non ci sono dati da visualizzare",
	"nl-NL": "Geen data om weer te geven. ",
	"pt-BR": "",
	"fi-FI": "Ei näytettäviä tietoja",
	"ja-JP": "表示するデータがありません",
};

// Location: GENERAL_TABLE_TEXTS
// Name: COLUMN_HEADER_ROLE_DESCRIPTION
// The values should be lowercase like any native ARIA role
const columnHeaderRoleDescription = {
	"en-US": "sort button",
	"en-GB": "sort button",
	"da-DK": "knappen sorter",
	"sv-SE": "sorteringsknapp",
	"de-DE": "schaltfläche 'sortieren'",
	"nb-NO": "sorteringsknapp",
	"fr-FR": "bouton trier",
	"es-ES": "botón ordenar",
	"it-IT": "pulsante ordina",
	"nl-NL": "sorteerknop",
	"pt-BR": "",
	"fi-FI": "lajittelupainike",
	"ja-JP": "並べ替えボタン",
};

// Location: GENERAL_DIALOG_TEXTS
// Name: CLOSE_DIALOG
const closeDialog = {
	"en-US": "Cancel dialog",
	"en-GB": "Cancel dialog",
	"da-DK": "Annuller dialogboks",
	"sv-SE": "Stäng dialogrutan",
	"de-DE": "Dialog schließen",
	"nb-NO": "Lukk dialogboks",
	"fr-FR": "Fermer la boîte de dialogue",
	"es-ES": "Cerrar el cuadro de diálogo",
	"it-IT": "Chiudi la finestra di dialogo",
	"nl-NL": "Dialoogvenster sluiten",
	"pt-BR": "Fechar caixa de diálogo",
	"fi-FI": "Sulje valintaikkuna",
	"ja-JP": "ダイアログを閉じる",
};

// Location: GENERAL_SPARK_LINE_TEXTS
// Name: ARIA_LABEL
const sparkLineAriaLabel = {
	"en-US": "Simple trend chart with [NUMBER_OF_POINTS] data points",
	"en-GB": "Simple trend chart with [NUMBER_OF_POINTS] data points",
	"da-DK": "Enkelt tendensdiagram med [NUMBER_OF_POINTS] datapunkter",
	"sv-SE": "Enkelt trenddiagram med [NUMBER_OF_POINTS] datapunkter",
	"de-DE": "Einfaches Trenddiagramm mit [NUMBER_OF_POINTS] Datenpunkten",
	"nb-NO": "Enkelt trenddiagram med [NUMBER_OF_POINTS] datapunkter",
	"fr-FR": "Graphique de tendance simple avec [NUMBER_OF_POINTS] points de données",
	"es-ES": "Gráfico de tendencias simples con [NUMBER_OF_POINTS] puntos de datos",
	"it-IT": "Grafico delle tendenze semplice con [NUMBER_OF_POINTS] punti dati",
	"nl-NL": "Eenvoudige trendgrafiek met [NUMBER_OF_POINTS] data punten",
	"pt-BR": "",
	"fi-FI": "Yksinkertainen trendikaavio, jossa on [NUMBER_OF_POINTS] datapistettä",
	"ja-JP": "データポイント数が[NUMBER_OF_POINTS]個の単純なトレンドチャート",
};

// TODO create translation key on server side
const remove = {
	"en-US": "Remove",
	"en-GB": "Remove",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// Location: GENERAL_SELECT_TEXTS
// Name: SEARCH
const search = {
	"en-US": "Search",
	"en-GB": "Search",
	"da-DK": "Søg",
	"sv-SE": "Sök",
	"de-DE": "Suche",
	"nb-NO": "Søk",
	"fr-FR": "Recherche",
	"es-ES": "Buscar",
	"it-IT": "Cerca",
	"nl-NL": "Zoeken",
	"pt-BR": "",
	"fi-FI": "Haku",
	"ja-JP": "検索",
};

// Location: GENERAL_SELECT_TEXTS
// Name: NO_MATCHES
const noMatches = {
	"en-US": "No matches",
	"en-GB": "No matches",
	"da-DK": "Ingen matches",
	"sv-SE": "Inga träffar",
	"de-DE": "Keine Treffer",
	"nb-NO": "Ingen treff",
	"fr-FR": "Aucune correspondance",
	"es-ES": "No hay coincidencias",
	"it-IT": "Nessuna corrispondenza",
	"nl-NL": "Geen overeenkomsten",
	"pt-BR": "",
	"fi-FI": "Ei osumia",
	"ja-JP": "一致なし",
};

// Location: GENERAL_SELECT_TEXTS
// Name: CREATE
const create = {
	"en-US": "Create",
	"en-GB": "Create",
	"da-DK": "Opret",
	"sv-SE": "Skapa",
	"de-DE": "Erstellen",
	"nb-NO": "Opprett",
	"fr-FR": "Créer",
	"es-ES": "Crear",
	"it-IT": "Crea",
	"nl-NL": "Maken",
	"pt-BR": "",
	"fi-FI": "Luo",
	"ja-JP": "作成",
};

// Location: GENERAL_SELECT_TEXTS
// Name: SELECT
const select = {
	"en-US": "Select",
	"en-GB": "Select",
	"da-DK": "Vælg",
	"sv-SE": "Välj",
	"de-DE": "Auswählen",
	"nb-NO": "Velg",
	"fr-FR": "Sélectionner",
	"es-ES": "Seleccionar",
	"it-IT": "Seleziona",
	"nl-NL": "Selecteren",
	"pt-BR": "",
	"fi-FI": "Valitse",
	"ja-JP": "選択",
};

// Location: GENERAL_SELECT_TEXTS
// Name: SELECTED
const selected = {
	"en-US": "selected",
	"en-GB": "selected",
	"da-DK": "valgt",
	"sv-SE": "markerade",
	"de-DE": "ausgewählt",
	"nb-NO": "valgt",
	"fr-FR": "Sélectionné(e)(s)",
	"es-ES": "seleccionados",
	"it-IT": "selezionato",
	"nl-NL": "geselecteerd",
	"pt-BR": "",
	"fi-FI": "valittu",
	"ja-JP": "選択済み",
};

// Location: GENERAL_SELECT_TEXTS
// Name: SELECTED_ITEMS
const selectedItems = {
	"en-US": "Selected items",
	"en-GB": "Selected items",
	"da-DK": "Valgte elementer",
	"sv-SE": "Valda objekt",
	"de-DE": "Ausgewählte Elemente",
	"nb-NO": "Valgte elementer",
	"fr-FR": "Éléments sélectionnés",
	"es-ES": "Elementos seleccionados",
	"it-IT": "Elementi selezionati",
	"nl-NL": "Geselecteerde items",
	"pt-BR": "",
	"fi-FI": "Valitut kohteet",
	"ja-JP": "選択した項目",
};

// Location: GENERAL_SELECT_TEXTS
// Name: SELECT_ALL
const selectAll = {
	"en-US": "Select all",
	"en-GB": "Select all",
	"da-DK": "Vælg alle",
	"sv-SE": "Välj alla",
	"de-DE": "Alle auswählen",
	"nb-NO": "Velg alle",
	"fr-FR": "Sélectionner tout",
	"es-ES": "Seleccionar todo",
	"it-IT": "Seleziona tutto",
	"nl-NL": "Alles selecteren",
	"pt-BR": "",
	"fi-FI": "Valitse kaikki",
	"ja-JP": "すべて選択",
};

// Location: GENERAL_SELECT_TEXTS
// Name: SELECT_ALL_MATCHING
const selectAllMatching = {
	"en-US": "Select all matching",
	"en-GB": "Select all matching",
	"da-DK": "Vælg alle, der matcher",
	"sv-SE": "Välj alla som matchar",
	"de-DE": "Alle übereinstimmenden auswählen",
	"nb-NO": "Velg alle samsvarende",
	"fr-FR": "Sélectionner toutes les correspondances",
	"es-ES": "Seleccionar todas las coincidencias",
	"it-IT": "Seleziona tutte le corrispondenze",
	"nl-NL": "Selecteer alle overeenkomende",
	"pt-BR": "",
	"fi-FI": "Valitse kaikki vastaavat",
	"ja-JP": "すべての一致を選択",
};

// Location: GENERAL_SELECT_TEXTS
// Name: DESELECT
const deselect = {
	"en-US": "Deselect",
	"en-GB": "Deselect",
	"da-DK": "Fravælg",
	"sv-SE": "Avmarkera",
	"de-DE": "Abwählen",
	"nb-NO": "Opphev valg",
	"fr-FR": "Désélectionner",
	"es-ES": "Anular la selección",
	"it-IT": "Deseleziona",
	"nl-NL": "Deselecteren",
	"pt-BR": "",
	"fi-FI": "Poista valinta",
	"ja-JP": "選択解除",
};

// Location: GENERAL_SELECT_TEXTS
// Name: DESELECT_ALL
const deselectAll = {
	"en-US": "Deselect all",
	"en-GB": "Deselect all",
	"da-DK": "Fravælg alle",
	"sv-SE": "Avmarkera alla",
	"de-DE": "Alle abwählen",
	"nb-NO": "Opphev valg av alle",
	"fr-FR": "Désélectionner tout",
	"es-ES": "Anular la selección de todo",
	"it-IT": "Deseleziona tutto",
	"nl-NL": "Alles deselecteren",
	"pt-BR": "",
	"fi-FI": "Poista kaikkien valinnat",
	"ja-JP": "すべて選択解除",
};

// Location: GENERAL_SELECT_TEXTS
// Name: MAX
const max = {
	"en-US": "max",
	"en-GB": "max",
	"da-DK": "maks",
	"sv-SE": "högst",
	"de-DE": "max",
	"nb-NO": "maks",
	"fr-FR": "max",
	"es-ES": "máx",
	"it-IT": "massimo",
	"nl-NL": "max",
	"pt-BR": "",
	"fi-FI": "enintään",
	"ja-JP": "最大",
};

// Location: GENERAL_DCI_GAUGE_TEXTS
// Name: DCI_SCORE_GAUGE
const dciScoreGauge = {
	"en-US": "DCI Score gauge",
	"en-GB": "DCI Score gauge",
	"da-DK": "Måler for DCI Score",
	"sv-SE": "DCI Score-mätare",
	"de-DE": "Anzeige des DCI Score",
	"nb-NO": "DCI Score-måler",
	"fr-FR": "Jauge DCI Score",
	"es-ES": "Indicador de DCI Score",
	"it-IT": "Indicatore DCI Score",
	"nl-NL": "DCI Score graadmeter",
	"pt-BR": "",
	"fi-FI": "DCI Score -mittari",
	"ja-JP": "DCI Scoreゲージ",
};

// Location: GENERAL_DCI_GAUGE_TEXTS
// Name: SITE_TARGET
const siteTarget = {
	"en-US": "Site target",
	"en-GB": "Site target",
	"da-DK": "Sitemål",
	"sv-SE": "Webbplatsmål",
	"de-DE": "Konformitätsziel",
	"nb-NO": "Nettstedsmål",
	"fr-FR": "Cible du site",
	"es-ES": "Objetivo del sitio web",
	"it-IT": "Obiettivo sito",
	"nl-NL": "Website doel",
	"pt-BR": "",
	"fi-FI": "Sivuston tavoitetaso",
	"ja-JP": "サイトの目標",
};

// Location: GENERAL_DCI_GAUGE_TEXTS
// Name: INDUSTRY_BENCHMARK
const industryBenchmark = {
	"en-US": "Industry benchmark",
	"en-GB": "Industry benchmark",
	"da-DK": "Benchmark for branchen",
	"sv-SE": "Industri Benchmark",
	"de-DE": "Branchenvergleichswert",
	"nb-NO": "Bransje-benchmark",
	"fr-FR": "Benchmark sectoriel",
	"es-ES": "Media del sector",
	"it-IT": "Benchmark del settore",
	"nl-NL": "Industrie benchmark",
	"pt-BR": "",
	"fi-FI": "Toimialan keskimääräinen tulos",
	"ja-JP": "業界ベンチマーク",
};

// Location: GENERAL_TREND_FORMATTER_TEXTS
// Name: DIRECTION_UP
const directionUp = {
	"en-US": "Up",
	"en-GB": "Up",
	"da-DK": "Op",
	"sv-SE": "Upp",
	"de-DE": "Nach oben",
	"nb-NO": "Opp",
	"fr-FR": "Haut",
	"es-ES": "Arriba",
	"it-IT": "Freccia Su",
	"nl-NL": "Omhoog",
	"pt-BR": "",
	"fi-FI": "Ylös",
	"ja-JP": "アップ",
};

// Location: GENERAL_TREND_FORMATTER_TEXTS
// Name: DIRECTION_DOWN
const directionDown = {
	"en-US": "Down",
	"en-GB": "Down",
	"da-DK": "Ned",
	"sv-SE": "Ner",
	"de-DE": "Nach unten",
	"nb-NO": "Ned",
	"fr-FR": "Bas",
	"es-ES": "Abajo",
	"it-IT": "Freccia Giù",
	"nl-NL": "Omlaag",
	"pt-BR": "",
	"fi-FI": "Alas",
	"ja-JP": "ダウン",
};

// Location: GENERAL_TREND_FORMATTER_TEXTS
// Name: DIRECTION_NEUTRAL
const directionNeutral = {
	"en-US": "No change",
	"en-GB": "No change",
	"da-DK": "Ingen ændring",
	"sv-SE": "Ingen förändring",
	"de-DE": "Keine Änderung",
	"nb-NO": "Ingen endring",
	"fr-FR": "Aucun changement",
	"es-ES": "Sin cambios",
	"it-IT": "Nessuna modifica",
	"nl-NL": "Geen wijziging",
	"pt-BR": "",
	"fi-FI": "Ei muutosta",
	"ja-JP": "変更なし",
};

// Location: SIComponentExportMenu
// Name: INCLUDE_SUBTABLES_OPTION
const includeSubtablesOption = {
	"en-US": 'Main table plus "[PROPERTY]" subtable',
	"en-GB": 'Main table plus "[PROPERTY]" subtable',
	"da-DK": 'Hovedtabel plus "[PROPERTY]"-undertabel',
	"sv-SE": "Huvudtabell och [PROPERTY]-undertabell",
	"de-DE": 'Haupttabelle plus "[PROPERTY]"-Untertabelle',
	"nb-NO": 'Hovedtabell og undertabellen "[PROPERTY]"',
	"fr-FR": 'Tableau principal plus sous-table "[PROPERTY]"',
	"es-ES": 'La tabla principal y la subtabla "[PROPERTY]"',
	"it-IT": 'Tabella principale più tabella secondaria "[PROPERTY]"',
	"nl-NL": 'Alleen hoofdtabel plus "[PROPERTY]" subtabel',
	"pt-BR": 'Tabela principal mais subtabela "[PROPERTY]"',
	"fi-FI": "Päätaulukko plus [PROPERTY]-alitaulukko",
	"ja-JP": "メインテーブルと「[PROPERTY]」サブテーブル",
};

// Location: SIComponentExportMenu
// Name: ALL_PAGES_TAGGED
const allPagesTagged = {
	"en-US": "All pages ([NUMBER_OF_PAGES] pages, [NUMBER_OF_ROWS] rows)",
	"en-GB": "All pages ([NUMBER_OF_PAGES] pages, [NUMBER_OF_ROWS] rows)",
	"da-DK": "Alle sider ([NUMBER_OF_PAGES] sider, [NUMBER_OF_ROWS] rækker)",
	"sv-SE": "Alla sidor ([NUMBER_OF_PAGES] sidor, [NUMBER_OF_ROWS] rader)",
	"de-DE": "Alle Seiten ([NUMBER_OF_PAGES] Seiten, [NUMBER_OF_ROWS] Zeilen)",
	"nb-NO": "Alle sider ([NUMBER_OF_PAGES] sider, [NUMBER_OF_ROWS] rader)",
	"fr-FR": "Toutes les pages ([NUMBER_OF_PAGES] pages, [NUMBER_OF_ROWS] lignes)",
	"es-ES": "Todas las páginas ([NUMBER_OF_PAGES] páginas, [NUMBER_OF_ROWS] filas)",
	"it-IT": "Tutte le pagine ([NUMBER_OF_PAGES] pagine, [NUMBER_OF_ROWS] righe)",
	"nl-NL": "Alle pagina's ([NUMBER_OF_PAGES] pagina's, [NUMBER_OF_ROWS] rijen)",
	"pt-BR": "Todas as páginas ([NUMBER_OF_PAGES] páginas, [NUMBER_OF_ROWS] linhas)",
	"fi-FI": "Kaikki sivut ([NUMBER_OF_PAGES] sivua, [NUMBER_OF_ROWS] riviä)",
	"ja-JP": "すべてのページ（[NUMBER_OF_PAGES]ページ、[NUMBER_OF_ROWS]行）",
};

// Location: SIComponentExportMenu
// Name: VISIBLE_PAGE
const visiblePage = {
	"en-US": "Current page only ([NUMBER_OF_ROWS] rows)",
	"en-GB": "Current page only ([NUMBER_OF_ROWS] rows)",
	"da-DK": "Kun aktuel side ([NUMBER_OF_ROWS] rækker)",
	"sv-SE": "Endast aktuell sida ([NUMBER_OF_ROWS] rader)",
	"de-DE": "Nur aktuelle Seite ([NUMBER_OF_ROWS] Reihen)",
	"nb-NO": "Bare gjeldende side ([NUMBER_OF_ROWS] rader)",
	"fr-FR": "Page actuelle uniquement ([NUMBER_OF_ROWS] lignes)",
	"es-ES": "Solo la página actual ([NUMBER_OF_ROWS] filas)",
	"it-IT": "Solo pagina corrente ([NUMBER_OF_ROWS] righe)",
	"nl-NL": "Alleen huidige pagina ([NUMBER_OF_ROWS] rijen)",
	"pt-BR": "Somente a página atual ([NUMBER_OF_ROWS] linhas)",
	"fi-FI": "Vain nykyinen sivu ([NUMBER_OF_ROWS] riviä)",
	"ja-JP": "現在のページのみ（[NUMBER_OF_ROWS]行）",
};

// Location: SIComponentExportMenu
// Name: PAGES
const pages = {
	"en-US": "Pages",
	"en-GB": "Pages",
	"da-DK": "Sider",
	"sv-SE": "Sidor",
	"de-DE": "Seiten",
	"nb-NO": "Sider",
	"fr-FR": "Pages",
	"es-ES": "Páginas",
	"it-IT": "Pagine",
	"nl-NL": "Pagina's",
	"pt-BR": "Páginas",
	"fi-FI": "Sivut",
	"ja-JP": "ページ",
};

// Location: SIComponentExportMenu
// Name: EXPORT
const exportLabel = {
	"en-US": "Export",
	"en-GB": "Export",
	"da-DK": "Eksport",
	"sv-SE": "Exportera",
	"de-DE": "Export",
	"nb-NO": "Eksporter",
	"fr-FR": "Exporter",
	"es-ES": "Exportar",
	"it-IT": "Esporta",
	"nl-NL": "Exporteren",
	"pt-BR": "",
	"fi-FI": "Vie",
	"ja-JP": "出力",
};

// Location: GDPR_TRACKED_SEARCHTERM_DETAILS
// Name: EXPORT_TO_CSV
const exportToCsv = {
	"en-US": "Export to CSV",
	"en-GB": "Export to CSV",
	"da-DK": "Eksportér til CSV",
	"sv-SE": "Exportera till CSV",
	"de-DE": "Nach CSV exportieren",
	"nb-NO": "Eksporter til CSV",
	"fr-FR": "Exporter au format CSV",
	"es-ES": "Exportar a CSV",
	"it-IT": "Esporta in CSV",
	"nl-NL": "Exporteren naar CSV",
	"pt-BR": "",
	"fi-FI": "Vie CSV-muotoon",
	"ja-JP": "CSVにエクスポート",
};

// Location: SIComponentExportMenu
// Name: EXPORT_TO_PNG
const exportToPng = {
	"en-US": "Export to PNG",
	"en-GB": "",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// Location: SIComponentExportMenu
// Name: INCLUDE_SUBTABLES
const includeSubtables = {
	"en-US": "Data",
	"en-GB": "Data",
	"da-DK": "Data",
	"sv-SE": "Data",
	"de-DE": "Daten",
	"nb-NO": "Data",
	"fr-FR": "Données",
	"es-ES": "Datos",
	"it-IT": "Dati",
	"nl-NL": "Data",
	"pt-BR": "Dados",
	"fi-FI": "Tiedot",
	"ja-JP": "データ",
};

// Location: SIComponentExportMenu
// Name: DONT_INCLUDE_SUBTABLES
const dontIncludeSubtables = {
	"en-US": "Main table only",
	"en-GB": "Main table only",
	"da-DK": "Kun hovedtabel",
	"sv-SE": "Endast huvudtabell",
	"de-DE": "Nur Haupttabelle",
	"nb-NO": "Bare hovedtabell",
	"fr-FR": "Tableau principal uniquement",
	"es-ES": "Solo la tabla principal",
	"it-IT": "Solo tabella principale",
	"nl-NL": "Alleen hoofdtabel",
	"pt-BR": "Somente a tabela principal",
	"fi-FI": "Vain päätaulukko",
	"ja-JP": "メインテーブルのみ",
};

// Location: PeriodPicker
// Name: NEXT_MONTH
const nextMonth = {
	"en-US": "Next month",
	"en-GB": "Next month",
	"da-DK": "Næste måned",
	"sv-SE": "Nästa månad",
	"de-DE": "Nächster Monat",
	"nb-NO": "Neste måned",
	"fr-FR": "Mois suivant",
	"es-ES": "Próximo mes",
	"it-IT": "Mese prossimo",
	"nl-NL": "Volgende maand",
	"pt-BR": "",
	"fi-FI": "Seuraava kuukausi",
	"ja-JP": "来月",
};

// Location: PeriodPicker
// Name: PREVIOUS_MONTH
const prevMonth = {
	"en-US": "Previous month",
	"en-GB": "Previous month",
	"da-DK": "Forrige måned",
	"sv-SE": "Föregående månad",
	"de-DE": "Vorheriger Monat",
	"nb-NO": "Forrige måned",
	"fr-FR": "Mois précédent",
	"es-ES": "Mes anterior",
	"it-IT": "Mese precedente",
	"nl-NL": "Vorige maand",
	"pt-BR": "",
	"fi-FI": "Edellinen kuukausi",
	"ja-JP": "前月",
};

// Location: PeriodPicker
// Name: NEXT_YEAR
const nextYear = {
	"en-US": "Next year",
	"en-GB": "Next year",
	"da-DK": "Næste år",
	"sv-SE": "Nästa år",
	"de-DE": "Nächstes Jahr",
	"nb-NO": "Neste år",
	"fr-FR": "Année suivante",
	"es-ES": "Próximo año",
	"it-IT": "Anno prossimo",
	"nl-NL": "Volgend jaar",
	"pt-BR": "",
	"fi-FI": "Seuraava vuosi",
	"ja-JP": "来年",
};

// Location: PeriodPicker
// Name: PREVIOUS_YEAR
const prevYear = {
	"en-US": "Previous year",
	"en-GB": "Previous year",
	"da-DK": "Forrige år",
	"sv-SE": "Föregående år",
	"de-DE": "Vorheriges Jahr",
	"nb-NO": "Forrige år",
	"fr-FR": "Année précédente",
	"es-ES": "Año anterior",
	"it-IT": "Anno precedente",
	"nl-NL": "Vorig jaar",
	"pt-BR": "",
	"fi-FI": "Edellinen vuosi",
	"ja-JP": "前年",
};

// Location: PeriodPicker
// Name: NEXT_DECADE
const nextDecade = {
	"en-US": "Next decade",
	"en-GB": "Next decade",
	"da-DK": "Næste årti",
	"sv-SE": "Nästa årtionde",
	"de-DE": "Nächstes Jahrzehnt",
	"nb-NO": "Neste tiår",
	"fr-FR": "Décennie suivante",
	"es-ES": "Próxima década",
	"it-IT": "Decennio prossimo",
	"nl-NL": "Volgend decennium",
	"pt-BR": "",
	"fi-FI": "Seuraava vuosikymmen",
	"ja-JP": "今後10年",
};

// Location: PeriodPicker
// Name: PREVIOUS_DECADE
const prevDecade = {
	"en-US": "Previous decade",
	"en-GB": "Previous decade",
	"da-DK": "Forrige årti",
	"sv-SE": "Föregående årtionde",
	"de-DE": "Vorheriges Jahrzehnt",
	"nb-NO": "Forrige tiår",
	"fr-FR": "Décennie précédente",
	"es-ES": "Década anterior",
	"it-IT": "Decennio precedente",
	"nl-NL": "Vorig decennium",
	"pt-BR": "",
	"fi-FI": "Edellinen vuosikymmen",
	"ja-JP": "過去10年",
};

// Location: PeriodPicker
// Name: NEXT_CENTURY
const nextCentury = {
	"en-US": "Next century",
	"en-GB": "Next century",
	"da-DK": "Næste århundrede",
	"sv-SE": "Nästa århundrade",
	"de-DE": "Nächstes Jahrhundert",
	"nb-NO": "Neste århundre",
	"fr-FR": "Siècle suivant",
	"es-ES": "Próximo siglo",
	"it-IT": "Secolo prossimo",
	"nl-NL": "Volgende eeuw",
	"pt-BR": "",
	"fi-FI": "Seuraava vuosisata",
	"ja-JP": "来世紀",
};

// Location: PeriodPicker
// Name: PREVIOUS_CENTURY
const prevCentury = {
	"en-US": "Previous century",
	"en-GB": "Previous century",
	"da-DK": "Forrige århundrede",
	"sv-SE": "Föregående århundrade",
	"de-DE": "Vorheriges Jahrhundert",
	"nb-NO": "Forrige århundre",
	"fr-FR": "Siècle précédent",
	"es-ES": "Siglo anterior",
	"it-IT": "Secolo precedente",
	"nl-NL": "Vorige eeuw",
	"pt-BR": "",
	"fi-FI": "Edellinen vuosisata",
	"ja-JP": "前世紀",
};

// TODO create translation key on server side
const selectDate = {
	"en-US": "Select a date",
	"en-GB": "Select a date",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// TODO create translation key on server side
const selectDateFor = {
	"en-US": "Select a date for X",
	"en-GB": "Select a date for X",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// TODO create translation key on server side
const invalidDate = {
	"en-US": "The date is invalid!",
	"en-GB": "The date is invalid!",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// TODO create translation key on server side
const dateRangeError = {
	"en-US": "This date is outside of the possible date range",
	"en-GB": "This date is outside of the possible date range",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// Location: GENERAL_CONTENT_SWITCHER_TEXTS
// Name: DEFAULT_ARIA_LABEL
// TODO Download and add translated translation keys
const contentSwitcher = {
	"en-US": "Content switcher",
	"en-GB": "Content switcher",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// Location: APPLICATION
// Name: APPLY_BUTTON
const apply = {
	"en-US": "Apply",
	"en-GB": "Apply",
	"da-DK": "Anvend",
	"sv-SE": "Tillämpa",
	"de-DE": "Anwenden",
	"nb-NO": "Bruk",
	"fr-FR": "Appliquer",
	"es-ES": "Aplicar",
	"it-IT": "Applica",
	"nl-NL": "Toepassen",
	"pt-BR": "Aplicar",
	"fi-FI": "Käytä",
	"ja-JP": "適用",
};

// Location: APPLICATION
// Name: CLEAR_ALL
const clearAll = {
	"en-US": "Clear all",
	"en-GB": "Clear all",
	"da-DK": "Ryd alle",
	"sv-SE": "Radera alla",
	"de-DE": "Alles löschen",
	"nb-NO": "Fjern alle",
	"fr-FR": "Tout effacer",
	"es-ES": "Borrar todo",
	"it-IT": "Cancella tutto",
	"nl-NL": "Alles wissen",
	"pt-BR": "",
	"fi-FI": "Poista kaikki",
	"ja-JP": "すべてクリア",
};

// Location: APPLICATION
// Name: FILTER
const filter = {
	"en-US": "Filter",
	"en-GB": "Filter",
	"da-DK": "Filtrer",
	"sv-SE": "Filtrera",
	"de-DE": "Filtern",
	"nb-NO": "Filtrer",
	"fr-FR": "Filtrer",
	"es-ES": "Filtrar",
	"it-IT": "Filtra",
	"nl-NL": "Filteren",
	"pt-BR": "",
	"fi-FI": "Suodata",
	"ja-JP": "フィルター",
};

// Location: APPLICATION
// Name: FILTERS_TEXT
const filters = {
	"en-US": "Filters",
	"en-GB": "Filters",
	"da-DK": "Filtre",
	"sv-SE": "Filter",
	"de-DE": "Filter",
	"nb-NO": "Filtre",
	"fr-FR": "Filtres",
	"es-ES": "Filtros",
	"it-IT": "Filtri",
	"nl-NL": "Filters",
	"pt-BR": "",
	"fi-FI": "Suodattimet",
	"ja-JP": "フィルター",
};

// Location: APPLICATION
// Name: FILTER_BY
const filterBy = {
	"en-US": "Filter by",
	"en-GB": "Filter by",
	"da-DK": "Filtrer efter",
	"sv-SE": "Filtrera efter",
	"de-DE": "Filtern nach",
	"nb-NO": "Filtrer etter",
	"fr-FR": "Filtrer par",
	"es-ES": "Filtrar por",
	"it-IT": "Filtra per",
	"nl-NL": "Filteren op:",
	"pt-BR": "",
	"fi-FI": "Suodatusperuste",
	"ja-JP": "フィルター基準",
};

// Location: APPLICATION
// Name: CLICK_TO_REMOVE
const clickToRemove = {
	"en-US": "click to remove",
	"en-GB": "click to remove",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// Location: APPLICATION
// Name: ACTIVE_FILTERS
const activeFilters = {
	"en-US": "Active filters",
	"en-GB": "Active filters",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// Location: APPLICATION
// Name: INTERACTIVE_LIST
const interactiveList = {
	"en-US": "Interactive list",
	"en-GB": "Interactive list",
	"da-DK": "Interaktiv liste",
	"sv-SE": "Interaktiv lista",
	"de-DE": "Interaktive Liste",
	"nb-NO": "Interaktiv liste",
	"fr-FR": "Liste interactive",
	"es-ES": "Lista interactiva",
	"it-IT": "Elenco interattivo",
	"nl-NL": "Interactieve lijst",
	"pt-BR": "",
	"fi-FI": "Vuorovaikutteinen luettelo",
	"ja-JP": "インタラクティブリスト",
};

// Location: SITE_PICKER
// Name: SELECT_A_SITE
const selectASite = {
	"en-US": "Select a site",
	"en-GB": "Select a site",
	"da-DK": "Vælg et site",
	"sv-SE": "Välj en webbplats",
	"de-DE": "Eine Website auswählen",
	"nb-NO": "Velg et nettsted",
	"fr-FR": "Sélectionner un site",
	"es-ES": "Seleccionar un sitio",
	"it-IT": "Seleziona un sito",
	"nl-NL": "Selecteer een site",
	"pt-BR": "Selecione um site",
	"fi-FI": "Valitse sivusto",
	"ja-JP": "サイトを選択",
};

// Location: SITE_PICKER
// Name: EDIT_SITES
const editSites = {
	"en-US": "Edit sites",
	"en-GB": "Edit sites",
	"da-DK": "Rediger sites",
	"sv-SE": "Redigera webbplatser",
	"de-DE": "Websites bearbeiten",
	"nb-NO": "Rediger nettsteder",
	"fr-FR": "Éditer les sites",
	"es-ES": "Editar sitios",
	"it-IT": "Modifica siti",
	"nl-NL": "Sites bewerken",
	"pt-BR": "Editar sites",
	"fi-FI": "Muokkaa sivustoja",
	"ja-JP": "サイトを編集",
};

// Location: SITE_PICKER
// Name: SHOWING_X_OF_Y_SITES
const showingXOfYSites = {
	"en-US": "Showing [COUNT] of [TOTAL] sites",
	"en-GB": "Showing [COUNT] of [TOTAL] sites",
	"da-DK": "Viser [COUNT] af [TOTAL] sites",
	"sv-SE": "Visar [COUNT] av [TOTAL] webbplatser",
	"de-DE": "[COUNT] von [TOTAL] Websites werden angezeigt",
	"nb-NO": "Viser [COUNT] av [TOTAL] nettsteder",
	"fr-FR": "Affichage de [COUNT] sites sur [TOTAL]",
	"es-ES": "Mostrando [COUNT] de [TOTAL] sitios",
	"it-IT": "Visualizzati [COUNT] di [TOTAL] siti",
	"nl-NL": "[COUNT] van de [TOTAL] sites weergegeven",
	"pt-BR": "Mostrando [COUNT] de [TOTAL] sites",
	"fi-FI": "Näytetään [COUNT]/[TOTAL] sivustoa",
	"ja-JP": "[TOTAL]個のサイトのうち[COUNT]個を表示",
};

// Location: SITE_PICKER
// Name: LOAD_MORE_LABEL
const loadXMore = {
	"en-US": "Load [COUNT] more",
	"en-GB": "Load [COUNT] more",
	"da-DK": "Indlæs [COUNT] mere",
	"sv-SE": "Läs in [COUNT] till",
	"de-DE": "[COUNT] weitere laden",
	"nb-NO": "Last inn [COUNT] til",
	"fr-FR": "Charger [COUNT] de plus",
	"es-ES": "Cargar [COUNT] más",
	"it-IT": "Carica altri [COUNT]",
	"nl-NL": "Laad [COUNT] meer",
	"pt-BR": "Carregar [COUNT] mais",
	"fi-FI": "Lataa vielä [COUNT]",
	"ja-JP": "さらに[COUNT]行読み込む",
};

// Location: PeriodPicker
// Name: NOW
const now = {
	"en-US": "Now",
	"en-GB": "Now",
	"da-DK": "Nu",
	"sv-SE": "Nu",
	"de-DE": "Jetzt",
	"nb-NO": "Nå",
	"fr-FR": "Maintenant",
	"es-ES": "Ahora",
	"it-IT": "Adesso",
	"nl-NL": "Nu",
	"pt-BR": "Agora",
	"fi-FI": "Nyt",
	"ja-JP": "今すぐ",
};

// Location: PeriodPicker
// Name: LAST_5_MINUTES
const last5Minutes = {
	"en-US": "Last 5 minutes",
	"en-GB": "Last 5 minutes",
	"da-DK": "Sidste 5 minutter",
	"sv-SE": "Senaste 5 minuterna",
	"de-DE": "Letzte 5 Minuten",
	"nb-NO": "Siste 5 minutter",
	"fr-FR": "5 dernières minutes",
	"es-ES": "Últimos 5 minutos",
	"it-IT": "Ultimi 5 minuti",
	"nl-NL": "Afgelopen vijf minuten",
	"pt-BR": "",
	"fi-FI": "Viimeiset 5 minuuttia",
	"ja-JP": "直近5分間",
};

// Location: PeriodPicker
// Name: TODAY
const today = {
	"en-US": "Today",
	"en-GB": "Today",
	"da-DK": "I dag",
	"sv-SE": "Idag",
	"de-DE": "Heute",
	"nb-NO": "I dag",
	"fr-FR": "Aujourd'hui",
	"es-ES": "Hoy",
	"it-IT": "Oggi",
	"nl-NL": "Vandaag",
	"pt-BR": "Hoje",
	"fi-FI": "Tänään",
	"ja-JP": "今日",
};

// Location: PeriodPicker
// Name: YESTERDAY
const yesterday = {
	"en-US": "Yesterday",
	"en-GB": "Yesterday",
	"da-DK": "I går",
	"sv-SE": "Igår",
	"de-DE": "Gestern",
	"nb-NO": "I går",
	"fr-FR": "Hier",
	"es-ES": "Ayer",
	"it-IT": "Ieri",
	"nl-NL": "Gisteren",
	"pt-BR": "Ontem",
	"fi-FI": "Eilen",
	"ja-JP": "昨日",
};

// Location: PeriodPicker
// Name: LAST_7_DAYS
const last7Days = {
	"en-US": "Last 7 days",
	"en-GB": "Last 7 days",
	"da-DK": "Sidste 7 dage",
	"sv-SE": "Senaste 7 dagarna",
	"de-DE": "Letzte 7 Tage",
	"nb-NO": "Siste 7 dager",
	"fr-FR": "Derniers 7 jours",
	"es-ES": "Últimos 7 días",
	"it-IT": "Ultimi 7 giorni",
	"nl-NL": "Afgelopen 7 dagen",
	"pt-BR": "Últimos 7 dias",
	"fi-FI": "Viimeiset 7 päivää",
	"ja-JP": "過去7日間",
};

// Location: PeriodPicker
// Name: LAST_14_DAYS
const last14Days = {
	"en-US": "Last 14 days",
	"en-GB": "Last 14 days",
	"da-DK": "De sidste 14 dage",
	"sv-SE": "Senaste 14 dagarna",
	"de-DE": "Letzte 14 Tage",
	"nb-NO": "De siste 14 dagene",
	"fr-FR": "14 derniers jours",
	"es-ES": "14 últimos días",
	"it-IT": "Ultimi 14 giorni",
	"nl-NL": "Afgelopen 14 dagen",
	"pt-BR": "Últimos 14 dias",
	"fi-FI": "Viimeiset 14 päivää",
	"ja-JP": "過去14日間",
};

// Location: PeriodPicker
// Name: LAST_30_DAYS
const last30Days = {
	"en-US": "Last 30 days",
	"en-GB": "Last 30 days",
	"da-DK": "De sidste 30 dage",
	"sv-SE": "Senaste 30 dagarna",
	"de-DE": "Letzte 30 Tage",
	"nb-NO": "De siste 30 dagene",
	"fr-FR": "30 derniers jours",
	"es-ES": "Últimos 30 días",
	"it-IT": "Ultimi 30 giorni",
	"nl-NL": "Afgelopen 30 dagen",
	"pt-BR": "Últimos 30 dias",
	"fi-FI": "Viimeiset 30 päivää",
	"ja-JP": "過去30日間",
};

// Location: PeriodPicker
// Name: LAST_365_DAYS
const last365Days = {
	"en-US": "Last 365 days",
	"en-GB": "Last 365 days",
	"da-DK": "De sidste 365 dage",
	"sv-SE": "Senaste 365 dagarna",
	"de-DE": "Letzte 365 Tage",
	"nb-NO": "De siste 365 dagene",
	"fr-FR": "365 derniers jours",
	"es-ES": "Últimos 365 días",
	"it-IT": "Ultimi 365 giorni",
	"nl-NL": "Afgelopen 365 dagen",
	"pt-BR": "Últimos 365 dias",
	"fi-FI": "Viimeiset 365 päivää",
	"ja-JP": "直近365日",
};

// Location: PeriodPicker
// Name: LAST_WEEK
const lastWeek = {
	"en-US": "Last week",
	"en-GB": "Last week",
	"da-DK": "Sidste uge",
	"sv-SE": "Föregående vecka",
	"de-DE": "Letzte Woche",
	"nb-NO": "Forrige uke",
	"fr-FR": "Semaine dernière",
	"es-ES": "La semana pasada",
	"it-IT": "Settimana scorsa",
	"nl-NL": "Afgelopen week",
	"pt-BR": "Última semana",
	"fi-FI": "Viime viikko",
	"ja-JP": "先週",
};

// Location: PeriodPicker
// Name: THIS_MONTH
const thisMonth = {
	"en-US": "This month",
	"en-GB": "This month",
	"da-DK": "Denne måned",
	"sv-SE": "Nuvarande månad",
	"de-DE": "Dieser Monat",
	"nb-NO": "",
	"fr-FR": "Ce mois-ci",
	"es-ES": "",
	"it-IT": "Questo mese",
	"nl-NL": "Deze maand",
	"pt-BR": "Este mês",
	"fi-FI": "Tämä kuukausi",
	"ja-JP": "今月",
};

// Location: PeriodPicker
// Name: LAST_MONTH
const lastMonth = {
	"en-US": "Last month",
	"en-GB": "Last month",
	"da-DK": "Sidste måned",
	"sv-SE": "Senaste månaden",
	"de-DE": "Letzten Monat",
	"nb-NO": "Forrige måned",
	"fr-FR": "Mois dernier",
	"es-ES": "Mes pasado",
	"it-IT": "Mese scorso",
	"nl-NL": "Afgelopen maand",
	"pt-BR": "Último mês",
	"fi-FI": "Viime kuukausi",
	"ja-JP": "先月",
};

// Location: PeriodPicker
// Name: THIS_QUARTER
const thisQuarter = {
	"en-US": "This quarter",
	"en-GB": "This quarter",
	"da-DK": "Dette kvartal",
	"sv-SE": "Detta kvartal",
	"de-DE": "Dieses Quartal",
	"nb-NO": "Dette kvartalet",
	"fr-FR": "Ce trimestre",
	"es-ES": "Este trimestre",
	"it-IT": "Questo trimestre",
	"nl-NL": "Dit kwartaal",
	"pt-BR": "Este trimestre",
	"fi-FI": "Tämä vuosineljännes",
	"ja-JP": "この四半期",
};

// Location: PeriodPicker
// Name: LAST_QUARTER
const lastQuarter = {
	"en-US": "Last quarter",
	"en-GB": "Last quarter",
	"da-DK": "Sidste kvartal",
	"sv-SE": "Senaste kvartalet",
	"de-DE": "Letztes Vierteljahr",
	"nb-NO": "Siste kvartal",
	"fr-FR": "Dernier trimestre",
	"es-ES": "Último trimestre",
	"it-IT": "Ultimo trimestre",
	"nl-NL": "Afgelopen kwartaal",
	"pt-BR": "Último trimestre",
	"fi-FI": "Edellinen neljännes",
	"ja-JP": "前四半期",
};

// Location: PeriodPicker
// Name: LAST_6_MONTHS
const last6Months = {
	"en-US": "Last 6 months",
	"en-GB": "Last 6 months",
	"da-DK": "Sidste 6 måneder",
	"sv-SE": "Senaste 6 månaderna",
	"de-DE": "In den letzten 6 Monaten",
	"nb-NO": "De siste seks månedene",
	"fr-FR": "6 derniers mois",
	"es-ES": "6 últimos meses",
	"it-IT": "Ultimi 6 mesi",
	"nl-NL": "Afgelopen 6 maanden",
	"pt-BR": "Últimos 6 meses",
	"fi-FI": "Viimeiset 6 kuukautta",
	"ja-JP": "直近6か月",
};

// Location: PeriodPicker
// Name: THIS_YEAR
const thisYear = {
	"en-US": "This year",
	"en-GB": "This year",
	"da-DK": "Dette år",
	"sv-SE": "Detta år",
	"de-DE": "Dieses Jahr",
	"nb-NO": "Dette året",
	"fr-FR": "Cette année",
	"es-ES": "Este año",
	"it-IT": "Quest'anno",
	"nl-NL": "Dit jaar",
	"pt-BR": "Este ano",
	"fi-FI": "Tämä vuosi",
	"ja-JP": "今年",
};

// Location: PeriodPicker
// Name: LAST_YEAR
const lastYear = {
	"en-US": "Last year",
	"en-GB": "Last year",
	"da-DK": "Sidste år",
	"sv-SE": "Föregående år",
	"de-DE": "Letztes Jahr",
	"nb-NO": "I fjor",
	"fr-FR": "Année précédente",
	"es-ES": "El año pasado",
	"it-IT": "Lo scorso anno",
	"nl-NL": "Vorig jaar",
	"pt-BR": "Ano passado",
	"fi-FI": "Viime vuosi",
	"ja-JP": "昨年",
};

// Location: PeriodPicker
// Name: CUSTOM_DATE
const customDate = {
	"en-US": "Custom",
	"en-GB": "Custom",
	"da-DK": "Brugerdefineret",
	"sv-SE": "Anpassad",
	"de-DE": "Benutzerdefiniert",
	"nb-NO": "Tilpasset",
	"fr-FR": "Personnalisation",
	"es-ES": "Personalizado",
	"it-IT": "Personalizzato",
	"nl-NL": "Custom",
	"pt-BR": "Personalizar",
	"fi-FI": "Muokattu",
	"ja-JP": "カスタム",
};

// Location: PeriodPicker
// Name: QUARTER_1
const quarter1 = {
	"en-US": "Q1",
	"en-GB": "Q1",
	"da-DK": "KV1",
	"sv-SE": "Första kvartalet",
	"de-DE": "1. Quartal",
	"nb-NO": "1. kvartal",
	"fr-FR": "Q1",
	"es-ES": "Q1",
	"it-IT": "Q1",
	"nl-NL": "Q1",
	"pt-BR": "Q1",
	"fi-FI": "K1",
	"ja-JP": "第1四半期",
};

// Location: PeriodPicker
// Name: QUARTER_2
const quarter2 = {
	"en-US": "Q2",
	"en-GB": "Q2",
	"da-DK": "KV2",
	"sv-SE": "Andra kvartalet",
	"de-DE": "2. Quartal",
	"nb-NO": "2. kvartal",
	"fr-FR": "Q2",
	"es-ES": "Q2",
	"it-IT": "Q2",
	"nl-NL": "Q2",
	"pt-BR": "Q2",
	"fi-FI": "K2",
	"ja-JP": "第2四半期",
};

// Location: PeriodPicker
// Name: QUARTER_3
const quarter3 = {
	"en-US": "Q3",
	"en-GB": "Q3",
	"da-DK": "KV3",
	"sv-SE": "Tredje kvartalet",
	"de-DE": "3. Quartal",
	"nb-NO": "3. kvartal",
	"fr-FR": "Q3",
	"es-ES": "Q3",
	"it-IT": "Q3",
	"nl-NL": "Q3",
	"pt-BR": "Q3",
	"fi-FI": "K3",
	"ja-JP": "第3四半期",
};

// Location: PeriodPicker
// Name: QUARTER_4
const quarter4 = {
	"en-US": "Q4",
	"en-GB": "Q4",
	"da-DK": "KV4",
	"sv-SE": "Fjärde kvartalet",
	"de-DE": "4. Quartal",
	"nb-NO": "4. kvartal",
	"fr-FR": "Q4",
	"es-ES": "Q4",
	"it-IT": "Q4",
	"nl-NL": "Q4",
	"pt-BR": "Q4",
	"fi-FI": "K4",
	"ja-JP": "第4四半期",
};

// Location: PeriodPicker
// Name: PERIOD
const period = {
	"en-US": "Date range",
	"en-GB": "Date range",
	"da-DK": "Datointerval",
	"sv-SE": "Datumintervall",
	"de-DE": "Datumsbereich",
	"nb-NO": "Datoperiode",
	"fr-FR": "Plage de dates",
	"es-ES": "Intervalo de fechas",
	"it-IT": "Intervallo date",
	"nl-NL": "datumbereik",
	"pt-BR": "Intervalo de datas",
	"fi-FI": "Päivämääräalue",
	"ja-JP": "日付範囲",
};

// Location: controls/datepicker
// Name: Clear
const clear = {
	"en-US": "Clear",
	"en-GB": "Clear",
	"da-DK": "Fjern filter",
	"sv-SE": "Ta bort",
	"de-DE": "Entfernen",
	"nb-NO": "Slett",
	"fr-FR": "Supprimer",
	"es-ES": "Borrar",
	"it-IT": "Cancella",
	"nl-NL": "Wissen",
	"pt-BR": "Limpar",
	"fi-FI": "Tyhjennä",
	"ja-JP": "クリア",
};

// Location: SideNavigation
// name: SearchInNavigationLabel
const searchInNavigationLabel = {
	"en-US": "Search",
	"en-GB": "Search",
	"da-DK": "Søg",
	"sv-SE": "Sök",
	"de-DE": "Suchen",
	"nb-NO": "Søk",
	"fr-FR": "Rechercher",
	"es-ES": "Buscar",
	"it-IT": "Cerca",
	"nl-NL": "Zoeken",
	"pt-BR": "",
	"fi-FI": "Haku",
	"ja-JP": "検索",
};

// Location: SideNavigation
// name: SearchInNavigationPlaceholder
const searchInNavigationPlaceholder = {
	"en-US": "Search in navigation",
	"en-GB": "Search in navigation",
	"da-DK": "Søg i navigation",
	"sv-SE": "Sök i navigering",
	"de-DE": "In der Navigation suchen",
	"nb-NO": "Søk i navigasjon",
	"fr-FR": "Rechercher dans la navigation",
	"es-ES": "Buscar en navegación",
	"it-IT": "Cerca nella navigazione",
	"nl-NL": "Zoeken in navigatie",
	"pt-BR": "",
	"fi-FI": "Hae navigoinnista",
	"ja-JP": "ナビゲーションで検索",
};

// Location: SideNavigation
// Name: CollapseNavigation
const collapseNavigation = {
	"en-US": "Collapse navigation",
	"en-GB": "Collapse navigation",
	"da-DK": "Skjul navigation",
	"sv-SE": "Dölj navigeringen",
	"de-DE": "Navigation reduzieren",
	"nb-NO": "Skjul navigasjonen",
	"fr-FR": "Réduire la navigation",
	"es-ES": "Contraer navegación",
	"it-IT": "Comprimi l'area di navigazione",
	"nl-NL": "Navigatie samenvouwen",
	"pt-BR": "",
	"fi-FI": "Pienennä navigointi",
	"ja-JP": "ナビゲーションを折りたたむ",
};

// Location: SideNavigation
// Name: ExpandNavigation
const expandNavigation = {
	"en-US": "Expand navigation",
	"en-GB": "Expand navigation",
	"da-DK": "Udvid navigation",
	"sv-SE": "Expandera navigeringen",
	"de-DE": "Navigation erweitern",
	"nb-NO": "Utvid navigasjonen",
	"fr-FR": "Développer la navigation",
	"es-ES": "Expandir navegación",
	"it-IT": "Espandi l'area di navigazione",
	"nl-NL": "Navigatie uitbreiden",
	"pt-BR": "",
	"fi-FI": "Suurenna navigointi",
	"ja-JP": "ナビゲーションを広げる",
};

// Location: SideNavigation
// Name: BackToMainNavigation
const backToMainNavigation = {
	"en-US": "Back to main navigation",
	"en-GB": "Back to main navigation",
	"da-DK": "Tilbage til hovednavigation",
	"sv-SE": "Tillbaka till huvudnavigeringen",
	"de-DE": "Zurück zur Hauptnavigation",
	"nb-NO": "Tilbake til hovednavigasjonen",
	"fr-FR": "Retour à la navigation principale",
	"es-ES": "Volver a la navegación principal",
	"it-IT": "Torna all'area di navigazione principale",
	"nl-NL": "Terug naar hoofdnavigatie",
	"pt-BR": "",
	"fi-FI": "Takaisin päänavigointiin",
	"ja-JP": "メインナビゲーションに戻る",
};

// Location: SideNavigation
// Name: BackToMainMenu
const backToMainMenu = {
	"en-US": "Back to main menu",
	"en-GB": "Back to main menu",
	"da-DK": "Tilbage til hovedmenu",
	"sv-SE": "Tillbaka till huvudnavigeringen", // TK from backToMainNavigation – will be updated later
	"de-DE": "Zurück zur Hauptnavigation", // TK from backToMainNavigation – will be updated later
	"nb-NO": "Tilbake til hovednavigasjonen", // TK from backToMainNavigation – will be updated later
	"fr-FR": "Retour à la navigation principale", // TK from backToMainNavigation – will be updated later
	"es-ES": "Volver a la navegación principal", // TK from backToMainNavigation – will be updated later
	"it-IT": "Torna all'area di navigazione principale", // TK from backToMainNavigation – will be updated later
	"nl-NL": "Terug naar hoofdnavigatie", // TK from backToMainNavigation – will be updated later
	"pt-BR": "",
	"fi-FI": "Takaisin päänavigointiin", // TK from backToMainNavigation – will be updated later
	"ja-JP": "メインナビゲーションに戻る", // TK from backToMainNavigation – will be updated later
};

// Location: si.controls
// Name: PROFILE
const profile = {
	"en-US": "Profile",
	"en-GB": "Profile",
	"da-DK": "Profil",
	"sv-SE": "Profil",
	"de-DE": "Profil",
	"nb-NO": "Profil",
	"fr-FR": "Profil",
	"es-ES": "Perfil",
	"it-IT": "Profilo",
	"nl-NL": "Profiel",
	"pt-BR": "Perfil",
	"fi-FI": "Profiili",
	"ja-JP": "プロフィール",
};

// Location: APPLICATION
// Name: SKIP_TO_CONTENT_LINK
const skipToContent = {
	"en-US": "Skip to main content",
	"en-GB": "Skip to main content",
	"da-DK": "Gå til hovedindhold",
	"sv-SE": "Gå till det huvudsakliga innehållet",
	"de-DE": "Zum Hauptinhalt springen",
	"nb-NO": "Gå til hovedinnhold",
	"fr-FR": "Accéder au contenu principal",
	"es-ES": "Ir al contenido principal",
	"it-IT": "Passa al contenuto principale",
	"nl-NL": "Naar hoofdinhoud",
	"pt-BR": "Ir para o conteúdo principal",
	"fi-FI": "Siirry pääsisältöön",
	"ja-JP": "メインコンテンツに移動",
};

// Location: PeriodPicker
// Name: PRESETS
const presets = {
	"en-US": "Presets",
	"en-GB": "Presets",
	"da-DK": "Forudindstillinger",
	"sv-SE": "Förinställda datum",
	"de-DE": "Voreinstellungen",
	"nb-NO": "Forhåndsdefinerte",
	"fr-FR": "Paramètres prédéfinis",
	"es-ES": "Valores preestablecidos",
	"it-IT": "Preimpostazioni",
	"nl-NL": "Voorinstellingen",
	"pt-BR": "Predefinições",
	"fi-FI": "Esiasetukset",
	"ja-JP": "プリセット",
};

// Location: PeriodPicker
// Name: YEAR_OVERVIEW
const yearOverview = {
	"en-US": "Year overview",
	"en-GB": "Year overview",
	"da-DK": "Årlig opsummering",
	"sv-SE": "Årsöversikt",
	"de-DE": "Jahresübersicht",
	"nb-NO": "Årsoversikt",
	"fr-FR": "Aperçu sur l'année",
	"es-ES": "Información general del año",
	"it-IT": "Panoramica anno",
	"nl-NL": "Jaaroverzicht",
	"pt-BR": "Visão geral do ano",
	"fi-FI": "Vuosiyhteenveto",
	"ja-JP": "年間一覧",
};

// Location: FANCYLIB
// Name: FORMATTED_NUMBER_MISSING
const numberMissing = {
	"en-US": "No number available",
	"en-GB": "No number available",
	"da-DK": "Intet tal tilgængeligt",
	"sv-SE": "Inget tal tillgängligt",
	"de-DE": "Keine Nummer verfügbar",
	"nb-NO": "Ingen tall tilgjengelig",
	"fr-FR": "Numéro non disponible",
	"es-ES": "Número no disponible",
	"it-IT": "Numero non disponibile",
	"nl-NL": "Nummer niet beschikbaar",
	"pt-BR": "Número não disponível",
	"fi-FI": "Numero ei saatavilla",
	"ja-JP": "利用可能な番号はありません",
};

// Location: FANCYLIB
// Name: FORMATTED_DATE_MISSING
const dateMissing = {
	"en-US": "Unknown date",
	"en-GB": "Unknown date",
	"da-DK": "Ukendt dato",
	"sv-SE": "Okänt datum",
	"de-DE": "Unbekanntes Datum",
	"nb-NO": "Ukjent dato",
	"fr-FR": "Date inconnue",
	"es-ES": "Fecha desconocida",
	"it-IT": "Data sconosciuta",
	"nl-NL": "Onbekende datum",
	"pt-BR": "Data desconhecida",
	"fi-FI": "Tuntematon päivämäärä",
	"ja-JP": "不明な日付",
};

// Location: APPLICATION
// Name: LIST_SKIP_LINK
const skipList = {
	"en-US": "Skip list",
	"en-GB": "Skip list",
	"da-DK": "Spring liste over",
	"sv-SE": "Hoppa över lista",
	"de-DE": "Liste überspringen",
	"nb-NO": "Hopp over liste",
	"fr-FR": "Passer la liste",
	"es-ES": "Saltar lista",
	"it-IT": "Salta elenco",
	"nl-NL": "Lijst overslaan",
	"pt-BR": "Pular lista",
	"fi-FI": "Ohita lista",
	"ja-JP": "リストをスキップ",
};

// Location: APPLICATION
// Name: LIST_PAGINATION_LABEL
const listPaginationLabel = {
	"en-US": "Pagination for list",
	"en-GB": "Pagination for list",
	"da-DK": "Paginering for liste",
	"sv-SE": "Paginering för lista",
	"de-DE": "Seitennummerierung für Liste",
	"nb-NO": "Paginering for liste",
	"fr-FR": "Pagination pour la liste",
	"es-ES": "Paginación para lista",
	"it-IT": "Paginazione per elenco",
	"nl-NL": "Paginering voor lijst",
	"pt-BR": "Paginação para lista",
	"fi-FI": "Sivutus luettelolle",
	"ja-JP": "リストのページネーション",
};

// Location: FANCY_COPY_BUTTON
// Name: COPY_TO_CLIPBOARD
const copyToClipboard = {
	"en-US": "Copy to clipboard",
	"en-GB": "Copy to clipboard",
	"da-DK": "Kopiér til udklipsholder",
	"sv-SE": "Kopiera till urklipp",
	"de-DE": "In die Zwischenablage kopieren",
	"nb-NO": "Kopier til utklippstavlen",
	"fr-FR": "Copier dans le presse-papiers",
	"es-ES": "Copiar al portapapeles",
	"it-IT": "Copia negli appunti",
	"nl-NL": "Kopiëren naar klembord",
	"pt-BR": "",
	"fi-FI": "Kopioi leikepöydälle",
	"ja-JP": "クリップボードにコピー",
};

// Location: settingsusers
// Name: EXPORT_EMAIL_EMAILS_COPIED
const copied = {
	"en-US": "Copied",
	"en-GB": "Copied",
	"da-DK": "Kopieret",
	"sv-SE": "Kopierad",
	"de-DE": "Kopiert",
	"nb-NO": "Kopiert",
	"fr-FR": "Copié",
	"es-ES": "Copiado",
	"it-IT": "Copiato",
	"nl-NL": "Gekopieerd",
	"pt-BR": "Copiado",
	"fi-FI": "Kopioitu",
	"ja-JP": "コピー済み",
};

// Location: FANCY_CHAT
// Name: SITEIMPROVE_AI
const aiAssistant = {
	"en-US": "AI Assistant",
	"en-GB": "AI Assistant",
	"da-DK": "AI-assistent",
	"sv-SE": "AI-assistent",
	"de-DE": "KI-Assistent",
	"nb-NO": "KI-assistent",
	"fr-FR": "Assistant IA",
	"es-ES": "Asistente de IA",
	"it-IT": "Assistente AI",
	"nl-NL": "AI-assistent",
	"pt-BR": "",
	"fi-FI": "Tekoälyavustaja",
	"ja-JP": "AIアシスタント",
};

// Location: FANCY_CHAT
// Name: CLOSE_CHAT_TOOLTIP
const closeChatTooltip = {
	"en-US": "Close",
	"en-GB": "Close",
	"da-DK": "Luk",
	"sv-SE": "Stäng",
	"de-DE": "Schließen",
	"nb-NO": "Lukk",
	"fr-FR": "Fermer",
	"es-ES": "Cerrar",
	"it-IT": "Chiudi",
	"nl-NL": "Sluiten",
	"pt-BR": "",
	"fi-FI": "Sulje",
	"ja-JP": "閉じる",
};

// Location: FANCY_CHAT
// Name: CHAT_FULL_SCREEN_TOOLTIP
const chatFullScreenTooltip = {
	"en-US": "Full-width",
	"en-GB": "Full-width",
	"da-DK": "Fuld bredde",
	"sv-SE": "Fullbredd",
	"de-DE": "Volle Breite",
	"nb-NO": "Full bredde",
	"fr-FR": "Pleine largeur",
	"es-ES": "Pantalla completa",
	"it-IT": "Larghezza intera",
	"nl-NL": "Volledige breedte",
	"pt-BR": "",
	"fi-FI": "Täysi leveys",
	"ja-JP": "全幅で表示",
};

// Location: FANCY_CHAT
// Name: CHAT_FULL_SCREEN_EXIT_TOOLTIP
const chatSidecar = {
	"en-US": "Sidecar",
	"en-GB": "Sidecar",
	"da-DK": "Sidepanel",
	"sv-SE": "Sidofönster",
	"de-DE": "Seitenleiste",
	"nb-NO": "Sidepanel",
	"fr-FR": "Panneau latéral",
	"es-ES": "Panel lateral",
	"it-IT": "Pannello laterale",
	"nl-NL": "Zijbalk",
	"pt-BR": "",
	"fi-FI": "Sivupaneeli",
	"ja-JP": "サイドバーに戻す",
};

// Location: FANCY_CHAT
// Name: CHAT_RETRY
const chatRetry = {
	"en-US": "Retry",
	"en-GB": "Retry",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// Location: FANCY_CHAT
// Name: MOVE_TO_BOTTOM
const moveToBottom = {
	"en-US": "Go to latest response",
	"en-GB": "Go to latest response",
	"da-DK": "Gå til seneste svar",
	"sv-SE": "Gå till senaste svar",
	"de-DE": "Zur letzten Antwort",
	"nb-NO": "Gå til siste svar",
	"fr-FR": "Voir la dernière réponse",
	"es-ES": "Ir a la última respuesta",
	"it-IT": "Vai alla risposta più recente",
	"nl-NL": "Naar laatste antwoord",
	"pt-BR": "",
	"fi-FI": "Siirry viimeisimpään vastaukseen",
	"ja-JP": "最新の応答に移動",
};

// Location: FANCY_CHAT
// Name: CLEAR_CHAT_TOOLTIP
const clearChatTooltip = {
	"en-US": "Clear conversation",
	"en-GB": "Clear conversation",
	"da-DK": "Ryd samtale",
	"sv-SE": "Rensa konversation",
	"de-DE": "Unterhaltung löschen",
	"nb-NO": "Tøm samtale",
	"fr-FR": "Effacer la conversation",
	"es-ES": "Borrar conversación",
	"it-IT": "Cancella conversazione",
	"nl-NL": "Gesprek wissen",
	"pt-BR": "",
	"fi-FI": "Tyhjennä keskustelu",
	"ja-JP": "会話をクリア",
};

// Location: FANCY_CHAT
// Name: CLEAR_CHAT_CONFIRM_TITLE
const clearChatConfirmTitle = {
	"en-US": "Clear this conversation?",
	"en-GB": "Clear this conversation?",
	"da-DK": "Ryd denne samtale?",
	"sv-SE": "Rensa den här konversationen?",
	"de-DE": "Diese Unterhaltung löschen?",
	"nb-NO": "Tømme denne samtalen?",
	"fr-FR": "Souhaitez-vous effacer cette conversation ?",
	"es-ES": "¿Borrar esta conversación?",
	"it-IT": "Cancellare questa conversazione?",
	"nl-NL": "Dit gesprek wissen?",
	"pt-BR": "",
	"fi-FI": "Tyhjennetäänkö tämä keskustelu?",
	"ja-JP": "この会話をクリアしますか?",
};

// Location: FANCY_CHAT
// Name: CLEAR_CHAT_CONFIRM_BODY
const clearChatConfirmBody = {
	"en-US": "This will permanently delete your current conversation history.",
	"en-GB": "This will permanently delete your current conversation history.",
	"da-DK": "Dette vil permanent slette din nuværende samtalehistorik.",
	"sv-SE": "Detta kommer att radera din nuvarande konversationshistorik permanent.",
	"de-DE": "Dadurch wird Ihr aktueller Unterhaltungsverlauf endgültig gelöscht.",
	"nb-NO": "Dette vil slette den nåværende samtalehistorikken din permanent.",
	"fr-FR": "Cette opération supprimera définitivement l’historique de la conversation en cours.",
	"es-ES": "Esto eliminará permanentemente el historial de su conversación actual.",
	"it-IT": "Questa operazione eliminerà definitivamente l'attuale cronologia delle conversazioni.",
	"nl-NL": "Je huidige gespreksgeschiedenis wordt permanent verwijderd.",
	"pt-BR": "",
	"fi-FI": "Keskustelun tyhjentäminen poistaa nykyisen keskusteluhistoriasi pysyvästi.",
	"ja-JP": "クリアすると、現在の会話履歴が完全に削除されます。",
};

// Location: FANCY_CHAT
// Name: CHAT_FOOTER_MESSAGE
const chatFooterMessage = {
	"en-US": "AI responses may contain errors. Check for correctness.",
	"en-GB": "AI responses may contain errors. Check for correctness.",
	"da-DK": "AI-svar kan indeholde fejl. Tjek, om det er korrekt.",
	"sv-SE": "AI-svar kan innehålla fel. Kontrollera att det är korrekt.",
	"de-DE": "KI-Antworten können Fehler enthalten. Prüfen Sie die Richtigkeit.",
	"nb-NO": "KI-svar kan inneholde feil. Kontroller at det er korrekt.",
	"fr-FR": "Les réponses de l'IA peuvent contenir des erreurs. Vérifiez leur exactitude.",
	"es-ES": "Las respuestas de la IA pueden contener errores. Compruebe que sean correctas.",
	"it-IT": "Le risposte generate da AI possono contenere errori. Verificane la correttezza.",
	"nl-NL": "AI-antwoorden kunnen fouten bevatten. Controleer of het klopt.",
	"pt-BR": "",
	"fi-FI": "Tekoälyvastauksissa voi olla virheitä. Tarkista paikkansapitävyys.",
	"ja-JP": "AIの応答にはエラーが含まれる可能性があります。正確かどうか確認してください。",
};

// Location: FANCY_CHAT
// Name: CHAT_COMPOSER_PLACEHOLDER
const chatComposerPlaceholder = {
	"en-US": "Ask a question or choose a prompt to get started",
	"en-GB": "Ask a question or choose a prompt to get started",
	"da-DK": "Stil et spørgsmål, eller vælg en prompt for at komme i gang",
	"sv-SE": "Ställ en fråga eller välj en prompt för att komma igång",
	"de-DE": "Stellen Sie eine Frage oder wählen Sie eine Eingabeaufforderung, um loszulegen",
	"nb-NO": "Still et spørsmål eller velg en ledetekst for å komme i gang",
	"fr-FR": "Posez une question ou choisissez une invite pour commencer.",
	"es-ES": "Haga una pregunta o elija un prompt para comenzar",
	"it-IT": "Fai una domanda o scegli un prompt per iniziare",
	"nl-NL": "Stel een vraag of kies een prompt om te beginnen",
	"pt-BR": "",
	"fi-FI": "Aloita kirjoittamalla kysymys tai valitsemalla kehote",
	"ja-JP": "質問するか、プロンプトを選択して開始してください",
};

// Location: FANCY_CHAT
// Name: CHAT_COMPOSER_PLACEHOLDER_ACTIVE_CONVERSATION
const chatComposerPlaceholderActiveConversation = {
	"en-US": "Continue the conversation",
	"en-GB": "Continue the conversation",
	"da-DK": "",
	"sv-SE": "Ställ en fråga eller välj en prompt för att komma igång",
	"de-DE": "Stellen Sie eine Frage oder wählen Sie eine Eingabeaufforderung, um loszulegen",
	"nb-NO": "Still et spørsmål eller velg en ledetekst for å komme i gang",
	"fr-FR": "Posez une question ou choisissez une invite pour commencer.",
	"es-ES": "Haga una pregunta o elija un prompt para comenzar",
	"it-IT": "Fai una domanda o scegli un prompt per iniziare",
	"nl-NL": "Stel een vraag of kies een prompt om te beginnen",
	"pt-BR": "",
	"fi-FI": "Aloita kirjoittamalla kysymys tai valitsemalla kehote",
	"ja-JP": "質問するか、プロンプトを選択して開始してください",
};

// Location: FANCY_CHAT
// Name: SEND
const send = {
	"en-US": "Send",
	"en-GB": "Send",
	"da-DK": "Send",
	"sv-SE": "Skicka",
	"de-DE": "Senden",
	"nb-NO": "Send",
	"fr-FR": "Envoyer",
	"es-ES": "Enviar",
	"it-IT": "Invia",
	"nl-NL": "Verzenden",
	"pt-BR": "",
	"fi-FI": "Lähetä",
	"ja-JP": "送信",
};

// Location: FANCY_CHAT
// Name: STOP
const stop = {
	"en-US": "Stop",
	"en-GB": "Stop",
	"da-DK": "Stop",
	"sv-SE": "Stopp",
	"de-DE": "Beenden",
	"nb-NO": "Stopp",
	"fr-FR": "Arrêter",
	"es-ES": "Detener",
	"it-IT": "Interrompi",
	"nl-NL": "Stoppen",
	"pt-BR": "",
	"fi-FI": "Lopeta",
	"ja-JP": "停止",
};

// Location: FANCY_CHAT
// Name: CHAT_FLOATING_CONTAINER_ARIA_LABEL
const chatFloatingContainerAriaLabel = {
	"en-US": "Chat with Siteimprove AI",
	"en-GB": "Chat with Siteimprove AI",
	"da-DK": "Chat med Siteimprove AI",
	"sv-SE": "Chatta med Siteimprove AI",
	"de-DE": "Chatten Sie mit Siteimprove AI",
	"nb-NO": "Chat med Siteimprove KI",
	"fr-FR": "Discuter avec l'IA de Siteimprove",
	"es-ES": "Chatear con la IA de Siteimprove",
	"it-IT": "Chatta con Siteimprove AI",
	"nl-NL": "Chat met Siteimprove AI",
	"pt-BR": "",
	"fi-FI": "Keskustele Siteimproven tekoälyn kanssa",
	"ja-JP": "Siteimprove AIとチャットする",
};

// Location: FANCY_CHAT
// Name: RESPONSE_READY
const responseReady = {
	"en-US": "Response ready.",
	"en-GB": "Response ready.",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// Location: FANCY_CHAT
// Name: WELCOME
const welcome = {
	"en-US": "Welcome!",
	"en-GB": "How can I help?",
	"da-DK": "Hvad kan jeg hjælpe med?",
	"sv-SE": "Hur kan jag hjälpa till?",
	"de-DE": "Wie kann ich helfen?",
	"nb-NO": "Hvordan kan jeg hjelpe?",
	"fr-FR": "En quoi puis-je vous aider ?",
	"es-ES": "¿En qué puedo ayudar?",
	"it-IT": "Come posso aiutarti?",
	"nl-NL": "Hoe kan ik helpen?",
	"pt-BR": "",
	"fi-FI": "Miten voin auttaa?",
	"ja-JP": "どうお手伝いしましょうか?",
};

// Location: FANCY_CHAT
// Name: THINKING
const thinking = {
	"en-US": "Thinking...",
	"en-GB": "Thinking...",
	"da-DK": "Tænker ...",
	"sv-SE": "Tänker …",
	"de-DE": "Denkprozess läuft ...",
	"nb-NO": "Tenker ...",
	"fr-FR": "Réflexion en cours…",
	"es-ES": "Pensando...",
	"it-IT": "Sto pensando...",
	"nl-NL": "Nadenken...",
	"pt-BR": "",
	"fi-FI": "Miettii...",
	"ja-JP": "思考中...",
};

// Location: FANCY_CHAT
// Name: STOPPED_GENERATING_RESPONSE
const stoppedGeneratingResponse = {
	"en-US": "Stopped generating a response. Continue when ready.",
	"en-GB": "Stopped generating a response. Continue when ready.",
	"da-DK": "",
	"sv-SE": "",
	"de-DE": "",
	"nb-NO": "",
	"fr-FR": "",
	"es-ES": "",
	"it-IT": "",
	"nl-NL": "",
	"pt-BR": "",
	"fi-FI": "",
	"ja-JP": "",
};

// Location: FANCY_CHAT
// Name: POSITIVE_FEEDBACK
const positiveFeedback = {
	"en-US": "Give positive feedback",
	"en-GB": "Give positive feedback",
	"da-DK": "Giv positiv feedback",
	"sv-SE": "Ge positiv feedback",
	"de-DE": "Geben Sie positives Feedback",
	"nb-NO": "Gi positiv tilbakemelding",
	"fr-FR": "Donner un feedback positif",
	"es-ES": "Enviar comentarios positivos",
	"it-IT": "Invia feedback positivo",
	"nl-NL": "Geef positieve feedback",
	"pt-BR": "",
	"fi-FI": "Anna positiivista palautetta",
	"ja-JP": "高評価を送信",
};

// Location: FANCY_CHAT
// Name: NEGATIVE_FEEDBACK
const negativeFeedback = {
	"en-US": "Give negative feedback",
	"en-GB": "Give negative feedback",
	"da-DK": "Giv negativ feedback",
	"sv-SE": "Ge negativ feedback",
	"de-DE": "Geben Sie negatives Feedback",
	"nb-NO": "Gi negativ tilbakemelding",
	"fr-FR": "Donner un feedback négatif",
	"es-ES": "Enviar comentario negativo",
	"it-IT": "Invia feedback negativo",
	"nl-NL": "Geef negatieve feedback",
	"pt-BR": "",
	"fi-FI": "Anna negatiivista palautetta",
	"ja-JP": "低評価を送信",
};

// Location: FANCY_CHAT
// Name: FEEDBACK_RECEIVED
const feedbackReceived = {
	"en-US": "Thank you for providing feedback",
	"en-GB": "Thank you for providing feedback",
	"da-DK": "Tak, fordi du gav feedback",
	"sv-SE": "Tack för din feedback",
	"de-DE": "Danke für Ihr Feedback",
	"nb-NO": "Takk for din tilbakemelding",
	"fr-FR": "Merci pour votre feedback",
	"es-ES": "Gracias por enviar sus comentarios",
	"it-IT": "Grazie per aver fornito il tuo feedback",
	"nl-NL": "Bedankt voor je feedback",
	"pt-BR": "",
	"fi-FI": "Kiitos palautteesta",
	"ja-JP": "フィードバックをお寄せいただき、ありがとうございました",
};

// Location: FANCY_CHAT
// Name: FEEDBACK_ERROR
const feedbackError = {
	"en-US": "Failed to submit feedback. Please try again",
	"en-GB": "Feedback submission failed. Try again.",
	"da-DK": "Indsendelse af feedback mislykkedes. Prøv igen.",
	"sv-SE": "Inlämnande av feedback misslyckades. Försök igen.",
	"de-DE": "Feedback-Übermittlung fehlgeschlagen. Versuchen Sie es erneut.",
	"nb-NO": "Innsending av tilbakemelding mislyktes. Prøv på nytt.",
	"fr-FR": "Échec de l'envoi du feedback. Veuillez réessayer.",
	"es-ES": "El envío de comentarios ha fallado. Vuelva a intentarlo.",
	"it-IT": "Invio del feedback non riuscito. Riprova.",
	"nl-NL": "Verzenden van feedback mislukt. Probeer het opnieuw.",
	"pt-BR": "",
	"fi-FI": "Palautteen lähettäminen epäonnistui. Yritä uudelleen.",
	"ja-JP": "フィードバックの送信に失敗しました。もう一度やり直してください。",
};

// Location: FANCY_CHAT
// Name: FEEDBACK_HEADER_TITLE
const feedbackHeaderTitle = {
	"en-US": "Help us improve Siteimprove AI",
	"en-GB": "Help us improve Siteimprove AI",
	"da-DK": "Hjælp os med at forbedre Siteimprove AI",
	"sv-SE": "Hjälp oss att förbättra Siteimprove AI",
	"de-DE": "Helfen Sie uns, Siteimprove AI zu verbessern",
	"nb-NO": "Hjelp oss med å forbedre Siteimprove KI",
	"fr-FR": "Aidez-nous à améliorer l'IA de Siteimprove",
	"es-ES": "Ayúdenos a mejorar la IA de Siteimprove",
	"it-IT": "Aiutaci a migliorare Siteimprove AI",
	"nl-NL": "Help ons Siteimprove AI te verbeteren",
	"pt-BR": "",
	"fi-FI": "Auta meitä parantamaan Siteimproven tekoälyä",
	"ja-JP": "Siteimprove AIの改善にご協力ください",
};

// Location: FANCY_CHAT
// Name: FEEDBACK_TEXTAREA_LABEL
const feedbackTextAreaLabel = {
	"en-US": "Please provide your feedback (optional)",
	"en-GB": "Provide your feedback (optional)",
	"da-DK": "Giv din feedback (valgfrit)",
	"sv-SE": "Ge feedback (valfritt)",
	"de-DE": "Geben Sie Ihr Feedback (optional)",
	"nb-NO": "Gi tilbakemelding (valgfritt)",
	"fr-FR": "Donnez votre feedback (facultatif)",
	"es-ES": "Proporcione sus comentarios (opcional)",
	"it-IT": "Fornisci il tuo feedback (facoltativo)",
	"nl-NL": "Geef je feedback (optioneel)",
	"pt-BR": "",
	"fi-FI": "Anna palautetta (valinnainen)",
	"ja-JP": "フィードバックをお寄せください（任意）",
};

// Location: FANCY_CHAT
// Name: FEEDBACK_TEXTAREA_PLACEHOLDER_POSITIVE
const feedbackTextAreaPlaceholderPositive = {
	"en-US": "What was satisfying about this response?",
	"en-GB": "What was satisfying about this response?",
	"da-DK": "Hvad var tilfredsstillende ved dette svar?",
	"sv-SE": "Vad var bra med detta svar?",
	"de-DE": "Was war an dieser Antwort befriedigend?",
	"nb-NO": "Hva var tilfredsstillende med denne responsen?",
	"fr-FR": "Qu'est-ce qui vous a plu dans cette réponse ?",
	"es-ES": "¿Qué le resultó satisfactorio de esta respuesta?",
	"it-IT": "Cosa hai trovato utile in questa risposta?",
	"nl-NL": "Wat was bevredigend aan dit antwoord?",
	"pt-BR": "",
	"fi-FI": "Mihin olit tyytyväinen tässä vastauksessa?",
	"ja-JP": "この応答で満足できた点は何ですか?",
};

// Location: FANCY_CHAT
// Name: FEEDBACK_TEXTAREA_PLACEHOLDER_NEGATIVE
const feedbackTextAreaPlaceholderNegative = {
	"en-US": "What was unsatisfying about this response?",
	"en-GB": "What was unsatisfying about this response?",
	"da-DK": "Hvad var utilfredsstillende ved dette svar?",
	"sv-SE": "Vad var inte bra med detta svar?",
	"de-DE": "Was war an dieser Antwort unbefriedigend?",
	"nb-NO": "Hva var utilfredsstillende med denne responsen?",
	"fr-FR": "Qu'est-ce qui vous a déplu dans cette réponse ?",
	"es-ES": "¿Qué le resultó insatisfactorio de esta respuesta?",
	"it-IT": "Cosa non ti ha soddisfatto di questa risposta?",
	"nl-NL": "Wat was onbevredigend aan dit antwoord?",
	"pt-BR": "",
	"fi-FI": "Mihin olit tyytymätön tässä vastauksessa?",
	"ja-JP": "この応答で満足できなかった点は何ですか?",
};

// Location: FANCY_CHAT
// Name: FEEDBACK_CONTACT_PERMISSION
const feedbackContactPermission = {
	"en-US": "Siteimprove can contact me about this feedback",
	"en-GB": "Siteimprove can contact me about this feedback.",
	"da-DK": "Siteimprove må kontakte mig angående denne feedback.",
	"sv-SE": "Siteimprove kan kontakta mig angående denna feedback.",
	"de-DE": "Siteimprove kann mich bezüglich dieses Feedbacks kontaktieren.",
	"nb-NO": "Siteimprove kan kontakte meg angående denne tilbakemeldingen.",
	"fr-FR": "Siteimprove peut me contacter au sujet de ce feedback.",
	"es-ES": "Siteimprove puede ponerse en contacto conmigo sobre estos comentarios.",
	"it-IT": "Siteimprove può contattarmi in merito a questo feedback.",
	"nl-NL": "Siteimprove mag contact met mij opnemen over deze feedback.",
	"pt-BR": "",
	"fi-FI": "Siteimprove saa ottaa minuun yhteyttä tätä palautetta koskien.",
	"ja-JP": "こちらのフィードバックに関してSiteimproveからの連絡を許可します。",
};

// Location: FANCY_CHAT
// Name: SEND_FEEDBACK
const sendFeedback = {
	"en-US": "Send feedback",
	"en-GB": "Send feedback",
	"da-DK": "Send feedback",
	"sv-SE": "Skicka feedback",
	"de-DE": "Feedback senden",
	"nb-NO": "Send tilbakemelding",
	"fr-FR": "Envoyer mon feedback",
	"es-ES": "Enviar comentarios",
	"it-IT": "Invia feedback",
	"nl-NL": "Feedback verzenden",
	"pt-BR": "",
	"fi-FI": "Lähetä palaute",
	"ja-JP": "フィードバックを送信",
};

// Location: FANCY_CHAT
// Name: ERRROR_MESSAGE_ILLUSTRATION_ALT_TEXT
const errorMessageIllustrationAltText = {
	"en-US": "Error illustration",
	"en-GB": "Error illustration",
	"da-DK": "Fejlillustration",
	"sv-SE": "Felillustration",
	"de-DE": "Fehlerdarstellung",
	"nb-NO": "Feil-illustrasjon",
	"fr-FR": "Illustration d'erreur",
	"es-ES": "Ilustración de error",
	"it-IT": "Illustrazione dell'errore",
	"nl-NL": "Foutillustratie",
	"pt-BR": "",
	"fi-FI": "Virheen kuvituskuva",
	"ja-JP": "エラーのイラスト",
};

// Location: SocialMedia.Facebook.Settings.UnlinkAccountsModal
// Name: CancelBtnText
const cancelBtnText = {
	"en-US": "Cancel",
	"en-GB": "Cancel",
	"da-DK": "Annuller",
	"sv-SE": "Avbryt",
	"de-DE": "Abbrechen",
	"nb-NO": "Avbryt",
	"fr-FR": "Annuler",
	"es-ES": "Cancelar",
	"it-IT": "Annulla",
	"nl-NL": "Annuleren",
	"pt-BR": "",
	"fi-FI": "Peruuta",
	"ja-JP": "キャンセル",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: REPORT_TITLE
const reportTitle = {
	"en-US": "Report",
	"en-GB": "Report",
	"da-DK": "Rapport",
	"sv-SE": "Rapport",
	"de-DE": "Bericht",
	"nb-NO": "Rapport",
	"fr-FR": "Rapport",
	"es-ES": "Informe",
	"it-IT": "Report",
	"nl-NL": "Rapport",
	"pt-BR": "",
	"fi-FI": "Raportti",
	"ja-JP": "レポート",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: LEFT_SIDEBAR
const leftSidebar = {
	"en-US": "Left sidebar",
	"en-GB": "Left sidebar",
	"da-DK": "Venstre sidepanel",
	"sv-SE": "Vänster sidofält",
	"de-DE": "Linke Seitenleiste",
	"nb-NO": "Venstre sidepanel",
	"fr-FR": "Barre latérale gauche",
	"es-ES": "Barra lateral izquierda",
	"it-IT": "Barra laterale sinistra",
	"nl-NL": "Linkerzijbalk",
	"pt-BR": "",
	"fi-FI": "Vasen sivupalkki",
	"ja-JP": "左サイドバー",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: REPORT_HEADER
const reportHeader = {
	"en-US": "Report header",
	"en-GB": "Report header",
	"da-DK": "Rapportoverskrift",
	"sv-SE": "Rapportrubrik",
	"de-DE": "Berichtskopf",
	"nb-NO": "Rapportoverskrift",
	"fr-FR": "En-tête du rapport",
	"es-ES": "Encabezado del informe",
	"it-IT": "Intestazione del report",
	"nl-NL": "Koptekst rapport",
	"pt-BR": "",
	"fi-FI": "Raportin otsikko",
	"ja-JP": "レポートのヘッダー",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: REPORT_CONTENT
const reportContent = {
	"en-US": "Report content",
	"en-GB": "Report content",
	"da-DK": "Rapportindhold",
	"sv-SE": "Rapportinnehåll",
	"de-DE": "Berichtsinhalt",
	"nb-NO": "Rapportinnhold",
	"fr-FR": "Contenu du rapport",
	"es-ES": "Contenido del informe",
	"it-IT": "Contenuto del report",
	"nl-NL": "Inhoud rapport",
	"pt-BR": "",
	"fi-FI": "Sisältöilmoitus",
	"ja-JP": "レポートのコンテンツ",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: RIGHT_SIDEBAR
const rightSidebar = {
	"en-US": "Right sidebar",
	"en-GB": "Right sidebar",
	"da-DK": "Højre sidepanel",
	"sv-SE": "Höger sidofält",
	"de-DE": "Rechte Seitenleiste",
	"nb-NO": "Høyre sidepanel",
	"fr-FR": "Barre latérale droite",
	"es-ES": "Barra lateral derecha",
	"it-IT": "Barra laterale destra",
	"nl-NL": "Rechterzijbalk",
	"pt-BR": "",
	"fi-FI": "Oikea sivupalkki",
	"ja-JP": "右サイドバー",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: TITLE_FALLBACK
const titleFallback = {
	"en-US": "No title",
	"en-GB": "No title",
	"da-DK": "Ingen titel",
	"sv-SE": "Ingen titel",
	"de-DE": "Kein Titel",
	"nb-NO": "Ingen tittel",
	"fr-FR": "Aucun titre",
	"es-ES": "Sin título",
	"it-IT": "Nessun titolo",
	"nl-NL": "Geen titel",
	"pt-BR": "",
	"fi-FI": "Ei otsikkoa",
	"ja-JP": "タイトルがありません",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: TITLE_FALLBACK_TOOLTIP
const titleFallbackTooltip = {
	"en-US": "The document title is either empty or unknown.",
	"en-GB": "The document title is either empty or unknown.",
	"da-DK": "Dokumentets titel er enten tom eller ukendt.",
	"sv-SE": "Dokumenttiteln är antingen tom eller okänd.",
	"de-DE": "Der Dokumenttitel ist entweder leer oder unbekannt.",
	"nb-NO": "Dokumenttittelen er enten tom eller ukjent.",
	"fr-FR": "Le titre du document est vide ou inconnu.",
	"es-ES": "El título del documento está en blanco o es desconocido.",
	"it-IT": "Il titolo del documento è vuoto o sconosciuto.",
	"nl-NL": "De titel van het document is leeg of onbekend.",
	"pt-BR": "",
	"fi-FI": "Asiakirjan otsikko on joko tyhjä tai tuntematon.",
	"ja-JP": "ドキュメントのタイトルが空白または不明です。",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: SHARE_LINK_HEADING
const shareLinkHeading = {
	"en-US": "Share report",
	"en-GB": "Share report",
	"da-DK": "Del rapport",
	"sv-SE": "Dela rapport",
	"de-DE": "Bericht teilen",
	"nb-NO": "Del rapport",
	"fr-FR": "Partager le rapport",
	"es-ES": "Compartir el informe",
	"it-IT": "Condividi report",
	"nl-NL": "Rapport delen",
	"pt-BR": "",
	"fi-FI": "Jaa raportti",
	"ja-JP": "レポートを共有",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: SHARE_LINK_ARIA_LABEL
const shareLinkAriaLabel = {
	"en-US": "Link to share report",
	"en-GB": "Link to share report",
	"da-DK": "Link til deling af rapport",
	"sv-SE": "Länk för att dela rapport",
	"de-DE": "Link zum Teilen des Berichts",
	"nb-NO": "Lenke for å dele rapporten",
	"fr-FR": "Lien de partage du rapport",
	"es-ES": "Enlace para compartir el informe",
	"it-IT": "Link alla condivisione del report",
	"nl-NL": "Link om rapport te delen",
	"pt-BR": "",
	"fi-FI": "Linkki raportin jakamiseen",
	"ja-JP": "レポートを共有するためのリンク",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: SHARE_LINK_TOOLTIP
const shareLinkTooltip = {
	"en-US": "Click to copy link to clipboard.",
	"en-GB": "Click to copy link to clipboard.",
	"da-DK": "Klik for at kopiere linket til udklipsholderen.",
	"sv-SE": "Klicka för att kopiera länken till urklipp.",
	"de-DE": "Klicken Sie hier, um den Link in die Zwischenablage zu kopieren.",
	"nb-NO": "Klikk for å kopiere lenken til utklippstavlen.",
	"fr-FR": "Cliquez pour copier le lien dans le presse-papiers.",
	"es-ES": "Haga clic para copiar el enlace al portapapeles.",
	"it-IT": "Fai clic per copiare il link negli appunti.",
	"nl-NL": "Klik om de link naar het klembord te kopiëren.",
	"pt-BR": "",
	"fi-FI": "Kopioi linkki leikepöydälle napsauttamalla.",
	"ja-JP": "クリックしてリンクをクリップボードにコピーします。",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: SHARE_LINK_TOOLTIP_COPIED
const shareLinkTooltipCopied = {
	"en-US": "Link copied to clipboard.",
	"en-GB": "Link copied to clipboard.",
	"da-DK": "Linket er kopieret til udklipsholderen.",
	"sv-SE": "Länken har kopierats till urklipp.",
	"de-DE": "Link in die Zwischenablage kopiert.",
	"nb-NO": "Lenken er kopiert til utklippstavlen.",
	"fr-FR": "Lien copié dans le presse-papiers.",
	"es-ES": "Se ha copiado el enlace al portapapeles.",
	"it-IT": "Link copiato negli appunti.",
	"nl-NL": "Link gekopieerd naar klembord.",
	"pt-BR": "",
	"fi-FI": "Linkki kopioitu leikepöydälle.",
	"ja-JP": "リンクがクリップボードにコピーされました。",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: SHARE_LINK_COPY_BUTTON
const shareLinkCopyButton = {
	"en-US": "Copy link",
	"en-GB": "Copy link",
	"da-DK": "Kopiér link",
	"sv-SE": "Kopiera länk",
	"de-DE": "Link kopieren",
	"nb-NO": "Kopier lenke",
	"fr-FR": "Copier le lien",
	"es-ES": "Copiar enlace",
	"it-IT": "Copia link",
	"nl-NL": "Link kopiëren",
	"pt-BR": "",
	"fi-FI": "Kopioi linkki",
	"ja-JP": "リンクをコピー",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: ACTION_BAR
const actionBar = {
	"en-US": "Action bar",
	"en-GB": "Action bar",
	"da-DK": "Handlingslinje",
	"sv-SE": "Åtgärdsfält",
	"de-DE": "Aktionsleiste",
	"nb-NO": "Handlingslinje",
	"fr-FR": "Barre d’action",
	"es-ES": "Barra de acciones",
	"it-IT": "Barra delle azioni",
	"nl-NL": "Actiebalk",
	"pt-BR": "",
	"fi-FI": "Toimintopalkki",
	"ja-JP": "アクションバー",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: ACTION_BAR_EXPAND
const actionBarExpand = {
	"en-US": "Expand action bar",
	"en-GB": "Expand action bar",
	"da-DK": "Udvid handlingslinjen",
	"sv-SE": "Visa åtgärdsfält",
	"de-DE": "Aktionsleiste erweitern",
	"nb-NO": "Utvid handlingslinje",
	"fr-FR": "Développer la barre d’action",
	"es-ES": "Expandir barra de acciones",
	"it-IT": "Espandi barra delle azioni",
	"nl-NL": "Actiebalk uitklappen",
	"pt-BR": "",
	"fi-FI": "Laajenna toimintopalkki",
	"ja-JP": "アクションバーを展開する",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: ACTION_BAR_COLLAPSE
const actionBarCollapse = {
	"en-US": "Collapse action bar",
	"en-GB": "Collapse action bar",
	"da-DK": "Skjul handlingslinjen",
	"sv-SE": "Dölj åtgärdsfält",
	"de-DE": "Aktionsleiste reduzieren",
	"nb-NO": "Skjul handlingslinje",
	"fr-FR": "Réduire la barre d’action",
	"es-ES": "Contraer barra de acciones",
	"it-IT": "Comprimi barra delle azioni",
	"nl-NL": "Actiebalk inklappen",
	"pt-BR": "",
	"fi-FI": "Pienennä toimintopalkki",
	"ja-JP": "アクションバーを折りたたむ",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: WIDGETS
const widgets = {
	"en-US": "Widgets",
	"en-GB": "Widgets",
	"da-DK": "Widgets",
	"sv-SE": "Widgets",
	"de-DE": "Widgets",
	"nb-NO": "Elementer",
	"fr-FR": "Widgets",
	"es-ES": "Widgets",
	"it-IT": "Widget",
	"nl-NL": "Widgets",
	"pt-BR": "",
	"fi-FI": "Widgetit",
	"ja-JP": "ウィジェット",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: FOOTER
const footer = {
	"en-US": "Additional information",
	"en-GB": "Additional information",
	"da-DK": "Yderligere oplysninger",
	"sv-SE": "Ytterligare information",
	"de-DE": "Weitere Informationen",
	"nb-NO": "Ytterligere informasjon",
	"fr-FR": "Informations complémentaires",
	"es-ES": "Información adicional",
	"it-IT": "Informazioni aggiuntive",
	"nl-NL": "Aanvullende informatie",
	"pt-BR": "",
	"fi-FI": "Lisätietoja",
	"ja-JP": "付加情報",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: BREADCRUMBS_ARIA_LABEL
const breadcrumbsAriaLabel = {
	"en-US": "Breadcrumbs - use to navigate back to overview",
	"en-GB": "Breadcrumbs - use to navigate back to overview",
	"da-DK": "Brødkrummer - bruges til at navigere tilbage til oversigten",
	"sv-SE": "Länkstigar - används för att navigera tillbaka till översikten",
	"de-DE": "Breadcrumbs - zur Rückkehr zur Übersicht verwenden",
	"nb-NO": "Navigasjonssti - brukes for å navigere tilbake til oversikt",
	"fr-FR": "Fil d’Ariane - à utiliser pour revenir à la vue d’ensemble",
	"es-ES": "Ruta de navegación para volver a la información general",
	"it-IT": "Breadcrumb - usa per tornare alla panoramica",
	"nl-NL": "Breadcrumbs - om terug te navigeren naar het overzicht",
	"pt-BR": "",
	"fi-FI": "Navigointipolku - käytä palataksesi takaisin yleiskatsaukseen",
	"ja-JP": "パンくずリスト - 概要に戻るために使用します",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: OCCURRENCES_LIST
const occurrencesList = {
	"en-US": "Occurrences",
	"en-GB": "Occurrences",
	"da-DK": "Forekomster",
	"sv-SE": "Förekomster",
	"de-DE": "Vorkommnisse",
	"nb-NO": "Forekomster",
	"fr-FR": "Occurrences",
	"es-ES": "Repeticiones",
	"it-IT": "Occorrenze",
	"nl-NL": "Gevallen",
	"pt-BR": "",
	"fi-FI": "Esiintymät",
	"ja-JP": "事例数",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: OCCURRENCES_COUNT
const occurrencesCount = {
	"en-US": "[COUNT] occurrences",
	"en-GB": "[COUNT] occurrences",
	"da-DK": "[COUNT] forekomster",
	"sv-SE": "[COUNT] förekomster",
	"de-DE": "[COUNT] Vorkommnisse",
	"nb-NO": "[COUNT] forekomster",
	"fr-FR": "[COUNT] occurrences",
	"es-ES": "[COUNT] repeticiones",
	"it-IT": "[COUNT] occorrenze",
	"nl-NL": "[COUNT] gevallen",
	"pt-BR": "",
	"fi-FI": "[COUNT] esiintymät",
	"ja-JP": "[COUNT]件",
};

// Location: FANCY_REPORT_TEMPLATE
// Name: MENU_ITEMS_ARIA_LABEL
const menuItemsAriaLabel = {
	"en-US": "MenuItems for [LIST_TITLE]",
	"en-GB": "MenuItems for [LIST_TITLE]",
	"da-DK": "Menuelementer for [LIST_TITLE]",
	"sv-SE": "Menyalternativ för [LIST_TITLE]",
	"de-DE": "Menüpunkte für [LIST_TITLE]",
	"nb-NO": "Menyelementer for [LIST_TITLE]",
	"fr-FR": "Éléments de menu pour [LIST_TITLE]",
	"es-ES": "Elementos de menú para [LIST_TITLE]",
	"it-IT": "ElementiMenu per [LIST_TITLE]",
	"nl-NL": "Menu-tems voor [LIST_TITLE]",
	"pt-BR": "",
	"fi-FI": "Valikkokohdat kohteelle [LIST_TITLE]",
	"ja-JP": "[LIST_TITLE]のメニュー項目",
};

const keys = {
	first,
	last,
	previous,
	next,
	page,
	pageXofY,
	defaultError,
	wholeNumberError,
	outOfBoundsError,
	create,
	directionDown,
	directionUp,
	directionNeutral,
	messageNeutral,
	messagePositive,
	messageWarning,
	messageNegative,
	dismissMessage,
	noMatches,
	search,
	skipChart,
	chartScreenReaderRegionLabel,
	screenReaderChartHeading,
	defaultChartTitle,
	chartTableSummary,
	chartContainerLabel,
	chartLegendItem,
	chartTypesMapTypeDescription,
	chartTypesCombinationChart,
	chartTypesDefaultSingle,
	chartTypesDefaultMultiple,
	chartTypesSplineSingle,
	chartTypesSplineMultiple,
	chartTypesLineSingle,
	chartTypesLineMultiple,
	chartTypesColumnSingle,
	chartTypesColumnMultiple,
	chartTypesBarSingle,
	chartTypesBarMultiple,
	chartTypesPieSingle,
	chartTypesPieMultiple,
	chartXAxisDescriptionSingular,
	chartXAxisDescriptionPlural,
	chartCategoryColumnHeader,
	chartDatetimeColumnHeader,
	chartYAxisDescriptionSingular,
	chartYAxisDescriptionPlural,
	chartSeriesDefault,
	chartSeriesDefaultCombination,
	chartSeriesLine,
	chartSeriesLineCombination,
	chartSeriesSpline,
	chartSeriesSplineCombination,
	chartSeriesColumn,
	chartSeriesColumnCombination,
	chartSeriesBar,
	chartSeriesBarCombination,
	chartSeriesPie,
	chartSeriesScatterCombination,
	chartSeriesMapCombination,
	chartSeriesMapbubbleCombination,
	chartXAxisDescription,
	chartYAxisDescription,
	chartContextMenuForLabel,
	chartContextMenuEnhancedContrastLabel,
	chartContextMenuEnhancedContrastTooltip,
	chartContextMenuTableViewLabel,
	chartContextMenuTableViewTooltip,
	noAnnotationsForThisChart,
	createAnnotationHelpText,
	noAnnotationsForChartPeriod,
	noAnnotationsForFavorite,
	noAnnotationsHelpTextForFavorite,
	annotations,
	annotationsDate,
	annotationsComment,
	annotationsCategory,
	annotationsCreatedBy,
	annotationsVisibility,
	allAnnotations,
	chartPeriodAnnotations,
	favoriteAnnotations,
	favoriteAnnotation,
	showAnnotations,
	showAnnotationsSrOnly,
	favorite,
	newAnnotation,
	annotationsShowFilter,
	createAnnotation,
	editAnnotation,
	saveAnnotation,
	edit,
	closeAnnotations,
	annotationsVisibilityField,
	annotationsCommentField,
	annotationsVisibleInField,
	annotationsSystemNotificationHelpText,
	annotationsGlobalVisibilityTooltip,
	everyone,
	onlyMe,
	skipTable,
	tableToolbarLabel,
	tableNoDataStateLabel,
	columnHeaderRoleDescription,
	closeDialog,
	sparkLineAriaLabel,
	remove,
	select,
	selected,
	selectedItems,
	selectAll,
	selectAllMatching,
	deselect,
	deselectAll,
	dciScoreGauge,
	industryBenchmark,
	siteTarget,
	max,
	includeSubtablesOption,
	dontIncludeSubtables,
	allPagesTagged,
	visiblePage,
	pages,
	exportLabel,
	exportToCsv,
	exportToPng,
	includeSubtables,
	nextMonth,
	prevMonth,
	nextYear,
	prevYear,
	nextDecade,
	prevDecade,
	nextCentury,
	prevCentury,
	selectDate,
	selectDateFor,
	invalidDate,
	dateRangeError,
	contentSwitcher,
	apply,
	clearAll,
	filter,
	filters,
	filterBy,
	clickToRemove,
	activeFilters,
	interactiveList,
	selectASite,
	editSites,
	showingXOfYSites,
	loadXMore,
	now,
	last5Minutes,
	today,
	yesterday,
	last7Days,
	last14Days,
	last30Days,
	last365Days,
	lastWeek,
	thisMonth,
	lastMonth,
	thisQuarter,
	lastQuarter,
	last6Months,
	thisYear,
	lastYear,
	customDate,
	quarter1,
	quarter2,
	quarter3,
	quarter4,
	period,
	clear,
	searchInNavigationLabel,
	searchInNavigationPlaceholder,
	collapseNavigation,
	expandNavigation,
	backToMainNavigation,
	backToMainMenu,
	profile,
	skipToContent,
	presets,
	yearOverview,
	numberMissing,
	dateMissing,
	skipList,
	listPaginationLabel,
	copyToClipboard,
	copied,
	aiAssistant,
	closeChatTooltip,
	clearChatTooltip,
	clearChatConfirmTitle,
	clearChatConfirmBody,
	chatFullScreenTooltip,
	chatSidecar,
	chatRetry,
	moveToBottom,
	chatFooterMessage,
	chatComposerPlaceholder,
	chatComposerPlaceholderActiveConversation,
	send,
	stop,
	chatFloatingContainerAriaLabel,
	responseReady,
	welcome,
	thinking,
	stoppedGeneratingResponse,
	positiveFeedback,
	negativeFeedback,
	feedbackReceived,
	feedbackError,
	feedbackHeaderTitle,
	feedbackTextAreaLabel,
	feedbackTextAreaPlaceholderPositive,
	feedbackTextAreaPlaceholderNegative,
	feedbackContactPermission,
	sendFeedback,
	errorMessageIllustrationAltText,
	cancelBtnText,
	reportTitle,
	leftSidebar,
	reportHeader,
	reportContent,
	rightSidebar,
	titleFallback,
	titleFallbackTooltip,
	shareLinkHeading,
	shareLinkAriaLabel,
	shareLinkTooltip,
	shareLinkTooltipCopied,
	shareLinkCopyButton,
	actionBar,
	actionBarExpand,
	actionBarCollapse,
	widgets,
	footer,
	occurrencesList,
	breadcrumbsAriaLabel,
	occurrencesCount,
	menuItemsAriaLabel,
};

export type TranslationKeys = keyof typeof keys;
export type Language =
	| "en-US"
	| "en-GB"
	| "da-DK"
	| "sv-SE"
	| "de-DE"
	| "nb-NO"
	| "fr-FR"
	| "es-ES"
	| "it-IT"
	| "nl-NL"
	| "pt-BR"
	| "fi-FI"
	| "ja-JP";

const extractLanguage = (lang: Language) =>
	Object.entries(keys).reduce(
		(a, [k, v]) => {
			a[k as TranslationKeys] = v[lang];
			return a;
		},
		{} as Record<TranslationKeys, string>
	);

export const translations: Record<Language, Record<TranslationKeys, string>> = {
	"en-US": extractLanguage("en-US"),
	"en-GB": extractLanguage("en-GB"),
	"da-DK": extractLanguage("da-DK"),
	"sv-SE": extractLanguage("sv-SE"),
	"de-DE": extractLanguage("de-DE"),
	"nb-NO": extractLanguage("nb-NO"),
	"fr-FR": extractLanguage("fr-FR"),
	"es-ES": extractLanguage("es-ES"),
	"it-IT": extractLanguage("it-IT"),
	"nl-NL": extractLanguage("nl-NL"),
	"pt-BR": extractLanguage("pt-BR"),
	"fi-FI": extractLanguage("fi-FI"),
	"ja-JP": extractLanguage("ja-JP"),
};

export function useLabTranslations(): Record<TranslationKeys, string> {
	const { lang, translationOverrides } = React.useContext(getOrCreateGlobalFancyContext());
	if (translationOverrides) {
		return { ...translations[lang], ...translationOverrides };
	} else {
		return translations[lang];
	}
}
